var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginScreenLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 960,
    viewBox: "0 0 1440 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_2009)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14_2009)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825.936 158.668L825.768 158.568L751.133 115.53V29.2539L751.301 29.1535L825.936 -13.8843L826.103 -13.7839L900.738 29.2539V115.53L900.571 115.631L825.936 158.668ZM751.77 115.129L825.936 157.899L900.068 115.129V29.5885L825.936 -13.1815L751.77 29.5885V115.129Z",
    fill: "url(#paint0_linear_14_2009)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M974.871 158.668L974.703 158.568L900.068 115.53V29.2539L900.236 29.1535L974.871 -13.8843L975.038 -13.7839L1049.67 29.2539V115.53L1049.51 115.631L974.871 158.668ZM900.738 115.129L974.871 157.899L1049.04 115.129V29.5885L974.871 -13.1815L900.738 29.5885V115.129Z",
    fill: "url(#paint1_linear_14_2009)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 158.668L1123.64 158.568L1049 115.53V29.2539L1049.17 29.1535L1123.81 -13.8843L1123.97 -13.7839L1198.61 29.2539V115.53L1198.44 115.631L1123.81 158.668ZM1049.67 115.129L1123.81 157.899L1197.94 115.129V29.5885L1123.81 -13.1815L1049.67 29.5885V115.129Z",
    fill: "url(#paint2_linear_14_2009)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 158.668L1272.61 158.568L1197.97 115.53V29.2539L1198.14 29.1535L1272.77 -13.8843L1272.94 -13.7839L1347.58 29.2539V115.53L1347.41 115.631L1272.77 158.668ZM1198.61 115.129L1272.77 157.899L1346.91 115.129V29.5885L1272.77 -13.1815L1198.61 29.5885V115.129Z",
    fill: "url(#paint3_linear_14_2009)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 147.356L1421.71 157.898L1347.54 115.128V29.6218L1421.71 -13.1482L1440 -2.60633V-3.37606L1421.88 -13.8176L1421.71 -13.918L1347.07 29.1533L1346.91 29.2202V115.53L1421.54 158.568L1421.71 158.668L1440 148.126V147.356Z",
    fill: "url(#paint4_linear_14_2009)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 287.514L155.493 287.413L80.8584 244.375V158.099L81.0259 157.999L155.661 114.961L155.828 115.061L230.463 158.099V244.375L230.296 244.476L155.661 287.514ZM81.5284 244.007L155.661 286.777L229.827 244.007V158.467L155.661 115.697L81.5284 158.467V244.007Z",
    fill: "url(#paint5_linear_14_2009)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M900.404 287.514L900.236 287.413L825.601 244.375V158.099L825.769 157.999L900.404 114.961L900.571 115.061L975.206 158.099V244.375L975.039 244.476L900.404 287.514ZM826.238 244.007L900.37 286.777L974.536 244.007V158.467L900.37 115.697L826.238 158.467V244.007Z",
    fill: "url(#paint6_linear_14_2009)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 287.514L1049.17 287.413L974.536 244.375V158.099L974.704 157.999L1049.34 114.961L1049.51 115.061L1124.14 158.099V244.375L1123.97 244.476L1049.34 287.514ZM975.206 244.007L1049.37 286.777L1123.5 244.007V158.467L1049.37 115.697L975.206 158.467V244.007Z",
    fill: "url(#paint7_linear_14_2009)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 287.514L1198.11 287.413L1123.47 244.375V158.099L1123.64 157.999L1198.27 114.961L1198.44 115.061L1273.08 158.099V244.375L1272.91 244.476L1198.27 287.514ZM1124.14 244.007L1198.27 286.777L1272.44 244.007V158.467L1198.27 115.697L1124.14 158.467V244.007Z",
    fill: "url(#paint8_linear_14_2009)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 287.514L1347.07 287.413L1272.44 244.375V158.099L1272.61 157.999L1347.24 114.961L1347.41 115.061L1422.04 158.099V244.375L1421.88 244.476L1347.24 287.514ZM1273.08 244.007L1347.21 286.777L1421.34 244.007V158.467L1347.21 115.697L1273.08 158.467V244.007Z",
    fill: "url(#paint9_linear_14_2009)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 254.382L1422.01 244.007V158.467L1440 148.126V147.356L1421.54 157.999L1421.38 158.099V244.375L1440 255.118V254.382Z",
    fill: "url(#paint10_linear_14_2009)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 416.392L1123.64 416.292L1049 373.254V286.978L1049.17 286.878L1123.81 243.84L1123.97 243.94L1198.61 286.978V373.254L1198.44 373.355L1123.81 416.392ZM1049.67 372.886L1123.81 415.656L1197.94 372.886V287.346L1123.81 244.576L1049.67 287.346V372.886Z",
    fill: "url(#paint11_linear_14_2009)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 416.392L1272.61 416.292L1197.97 373.254V286.978L1198.14 286.878L1272.77 243.84L1272.94 243.94L1347.58 286.978V373.254L1347.41 373.355L1272.77 416.392ZM1198.61 372.886L1272.77 415.656L1346.91 372.886V287.346L1272.77 244.576L1198.61 287.346V372.886Z",
    fill: "url(#paint12_linear_14_2009)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 405.081L1421.71 415.656L1347.54 372.886V287.346L1421.71 244.576L1440 255.118V254.382L1421.88 243.907L1421.71 243.807L1347.07 286.878L1346.91 286.978V373.255L1421.54 416.292L1421.71 416.393L1440 405.851V405.081Z",
    fill: "url(#paint13_linear_14_2009)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 545.238L1198.11 545.138L1123.47 502.1V415.824L1123.64 415.723L1198.27 372.686L1198.44 372.786L1273.08 415.824V502.1L1272.91 502.2L1198.27 545.238ZM1124.14 501.732L1198.27 544.502L1272.44 501.732V416.192L1198.27 373.422L1124.14 416.192V501.732Z",
    fill: "url(#paint14_linear_14_2009)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 545.238L1347.07 545.138L1272.44 502.1V415.824L1272.61 415.723L1347.24 372.686L1347.41 372.786L1422.04 415.824V502.1L1421.88 502.2L1347.24 545.238ZM1273.08 501.732L1347.21 544.502L1421.34 501.732V416.192L1347.21 373.422L1273.08 416.192V501.732Z",
    fill: "url(#paint15_linear_14_2009)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 512.106L1422.01 501.732V416.192L1440 405.851V405.081L1421.54 415.723L1421.38 415.824V502.1L1440 512.843V512.106Z",
    fill: "url(#paint16_linear_14_2009)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 674.117L229.994 674.017L155.359 630.979V544.703L155.527 544.602L230.162 501.564L230.329 501.665L304.964 544.703V630.979L304.797 631.079L230.162 674.117ZM155.996 630.611L230.128 673.381L304.261 630.611V545.071L230.128 502.301L155.996 545.071V630.611Z",
    fill: "url(#paint17_linear_14_2009)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 674.117L1272.61 674.017L1197.97 630.979V544.703L1198.14 544.602L1272.77 501.564L1272.94 501.665L1347.58 544.703V630.979L1347.41 631.079L1272.77 674.117ZM1198.61 630.611L1272.77 673.381L1346.91 630.611V545.071L1272.77 502.301L1198.61 545.071V630.611Z",
    fill: "url(#paint18_linear_14_2009)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 662.839L1421.71 673.381L1347.54 630.611V545.071L1421.71 502.301L1440 512.843V512.106L1421.88 501.631L1421.71 501.564L1347.07 544.602L1346.91 544.703V630.979L1421.54 674.017L1421.71 674.117L1440 663.575V662.839Z",
    fill: "url(#paint19_linear_14_2009)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 802.996L155.493 802.896L80.8584 759.858V673.582L81.0259 673.481L155.661 630.443L155.828 630.544L230.463 673.582V759.858L230.296 759.958L155.661 802.996ZM81.5284 759.456L155.661 802.226L229.827 759.456V673.916L155.661 631.146L81.5284 673.916V759.456Z",
    fill: "url(#paint20_linear_14_2009)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M304.63 802.996L304.462 802.896L229.827 759.858V673.582L229.995 673.481L304.63 630.443L304.797 630.544L379.432 673.582V759.858L379.265 759.958L304.63 802.996ZM230.464 759.456L304.596 802.226L378.729 759.456V673.916L304.596 631.146L230.464 673.916V759.456Z",
    fill: "url(#paint21_linear_14_2009)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M453.565 802.996L453.397 802.896L378.762 759.858V673.582L378.93 673.481L453.565 630.443L453.732 630.544L528.367 673.582V759.858L528.2 759.958L453.565 802.996ZM379.399 759.456L453.531 802.226L527.664 759.456V673.916L453.531 631.146L379.399 673.916V759.456Z",
    fill: "url(#paint22_linear_14_2009)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 802.996L602.332 802.896L527.697 759.858V673.582L527.865 673.481L602.5 630.443L602.667 630.544L677.302 673.582V759.858L677.135 759.958L602.5 802.996ZM528.367 759.456L602.533 802.226L676.666 759.456V673.916L602.533 631.146L528.367 673.916V759.456Z",
    fill: "url(#paint23_linear_14_2009)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 769.831L1422.01 759.456V673.95L1440 663.575V662.839L1421.54 673.481L1421.38 673.548V759.858L1440 770.567V769.831Z",
    fill: "url(#paint24_linear_14_2009)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 931.842L229.994 931.741L155.359 888.704V802.427L155.527 802.327L230.162 759.289L230.329 759.389L304.964 802.427V888.704L304.797 888.804L230.162 931.842ZM155.996 888.335L230.128 931.105L304.261 888.335V802.795L230.128 760.025L155.996 802.795V888.335Z",
    fill: "url(#paint25_linear_14_2009)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M379.097 931.842L378.929 931.741L304.294 888.704V802.427L304.462 802.327L379.097 759.289L379.264 759.389L453.9 802.427V888.704L453.732 888.804L379.097 931.842ZM304.931 888.335L379.097 931.105L453.23 888.335V802.795L379.097 760.025L304.931 802.795V888.335Z",
    fill: "url(#paint26_linear_14_2009)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M528.032 931.842L527.865 931.741L453.229 888.704V802.427L453.397 802.327L528.032 759.289L528.199 759.389L602.835 802.427V888.704L602.667 888.804L528.032 931.842ZM453.899 888.335L528.032 931.105L602.165 888.335V802.795L528.032 760.025L453.899 802.795V888.335Z",
    fill: "url(#paint27_linear_14_2009)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5286 980V931.674L155.661 888.904L229.827 931.674V980H230.464V931.306L155.829 888.235L155.661 888.134L81.0261 931.206L80.8921 931.306V980H81.5286Z",
    fill: "url(#paint28_linear_14_2009)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M230.464 980V931.674L304.63 888.904L378.762 931.674V980H379.399V931.306L304.797 888.235L304.63 888.134L229.995 931.206L229.827 931.306V980H230.464Z",
    fill: "url(#paint29_linear_14_2009)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.399 980V931.674L453.565 888.904L527.697 931.674V980H528.367V931.306L453.732 888.235L453.565 888.134L378.93 931.206L378.762 931.306V980H379.399Z",
    fill: "url(#paint30_linear_14_2009)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M528.367 980V931.674L602.5 888.904L676.666 931.674V980H677.302V931.306L602.667 888.235L602.5 888.134L527.865 931.206L527.697 931.306V980H528.367Z",
    fill: "url(#paint31_linear_14_2009)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.14 980V931.674L1198.27 888.904L1272.44 931.674V980H1273.08V931.306L1198.44 888.235L1198.27 888.134L1123.64 931.206L1123.5 931.306V980H1124.14Z",
    fill: "url(#paint32_linear_14_2009)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.08 980V931.674L1347.24 888.904L1421.37 931.674V980H1422.01V931.306L1347.38 888.235L1347.24 888.134L1272.61 931.206L1272.44 931.306V980H1273.08Z",
    fill: "url(#paint33_linear_14_2009)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.7 148.026L1003.95 91.0663V-22.8532L1102.7 -79.813L1201.46 -22.8532V91.0663L1102.7 148.026ZM1007.33 89.1587L1102.7 144.177L1198.07 89.1587V-20.8787L1102.7 -75.8974L1007.33 -20.8787V89.1587Z",
    fill: "url(#paint34_linear_14_2009)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.83 148.026L1198.07 91.0663V-22.8532L1296.83 -79.813L1395.58 -22.8532V91.0663L1296.83 148.026ZM1201.46 89.1587L1296.83 144.177L1392.2 89.1587V-20.8787L1296.83 -75.8974L1201.46 -20.8787V89.1587Z",
    fill: "url(#paint35_linear_14_2009)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 114.761L1395.55 89.1588V-20.8787L1440 -46.5139V-50.396L1392.2 -22.8197V91.0998L1440 118.643V114.761Z",
    fill: "url(#paint36_linear_14_2009)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.75 315.994L1100.99 259.034V145.115L1199.75 88.1548L1298.5 145.115V259.034L1199.75 315.994ZM1104.38 257.093L1199.75 312.112L1295.12 257.093V147.056L1199.75 92.0369L1104.38 147.056V257.093Z",
    fill: "url(#paint37_linear_14_2009)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 285.506L1393.87 312.111L1298.5 257.093V147.055L1393.87 92.0701L1440 118.642V114.76L1393.87 88.188L1295.12 145.114V259.034L1393.87 315.994L1440 289.388V285.506Z",
    fill: "url(#paint38_linear_14_2009)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 284.937V288.853L33.3907 315.023V425.027L-12 451.198V455.114L36.7406 426.968V313.082L-12 284.937Z",
    fill: "url(#paint39_linear_14_2009)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M132.112 483.928L33.3574 426.968V313.049L132.112 256.089L230.866 313.049V426.968L132.112 483.928ZM36.7408 425.027L132.112 480.046L227.482 425.027V314.99L132.112 259.971L36.7408 314.99V425.027Z",
    fill: "url(#paint40_linear_14_2009)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M326.236 483.928L227.482 426.968V313.049L326.236 256.089L424.99 313.049V426.968L326.236 483.928ZM230.865 425.027L326.236 480.046L421.607 425.027V314.99L326.236 259.971L230.865 314.99V425.027Z",
    fill: "url(#paint41_linear_14_2009)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 450.662L1395.55 425.027V315.023L1440 289.388V285.506L1392.2 313.082V426.968L1440 454.545V450.662Z",
    fill: "url(#paint42_linear_14_2009)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0656 424.057L-12 451.198V455.113L35.0656 427.939L130.436 482.957V592.995L35.0656 647.98L-12 620.839V624.721L35.0656 651.896L133.82 594.936V481.016L35.0656 424.057Z",
    fill: "url(#paint43_linear_14_2009)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M229.191 651.896L130.437 594.936V481.016L229.191 424.057L327.945 481.016V594.936L229.191 651.896ZM133.82 592.995L229.191 648.014L324.561 592.995V482.957L229.191 427.939L133.82 482.957V592.995Z",
    fill: "url(#paint44_linear_14_2009)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M423.282 651.896L324.528 594.936V481.016L423.282 424.057L522.036 481.016V594.936L423.282 651.896ZM327.911 592.995L423.282 648.014L518.653 592.995V482.957L423.282 427.939L327.911 482.957V592.995Z",
    fill: "url(#paint45_linear_14_2009)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 620.839V624.721L33.3907 650.925V760.929L-12 787.1V790.982L36.7406 762.87V648.951L-12 620.839Z",
    fill: "url(#paint46_linear_14_2009)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.112 819.83L33.3574 762.87V648.95L132.112 591.991L230.866 648.95V762.87L132.112 819.83ZM36.7408 760.929L132.112 815.948L227.482 760.929V650.892L132.112 595.873L36.7408 650.892V760.929Z",
    fill: "url(#paint47_linear_14_2009)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M326.236 819.83L227.482 762.87V648.95L326.236 591.991L424.99 648.95V762.87L326.236 819.83ZM230.865 760.929L326.236 815.948L421.607 760.929V650.892L326.236 595.873L230.865 650.892V760.929Z",
    fill: "url(#paint48_linear_14_2009)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.83 819.83L1198.07 762.87V648.95L1296.83 591.991L1395.58 648.95V762.87L1296.83 819.83ZM1201.46 760.929L1296.83 815.948L1392.2 760.929V650.892L1296.83 595.873L1201.46 650.892V760.929Z",
    fill: "url(#paint49_linear_14_2009)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 960.623L21.5992 980H28.3324L-12 956.741V960.623Z",
    fill: "url(#paint50_linear_14_2009)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0656 759.958L-12 787.1V790.982L35.0656 763.841L130.436 818.859V928.863L41.7989 980H48.5321L133.82 930.838V816.918L35.0656 759.958Z",
    fill: "url(#paint51_linear_14_2009)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M222.457 980L133.82 928.863V818.859L229.191 763.841L324.561 818.859V928.863L235.924 980H242.657L327.911 930.838V816.918L229.191 759.958L130.437 816.918V930.838L215.691 980H222.457Z",
    fill: "url(#paint52_linear_14_2009)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M416.548 980L327.911 928.863V818.859L423.282 763.841L518.652 818.859V928.863L430.048 980H436.782L522.036 930.838V816.918L423.282 759.958L324.561 816.918V930.838L409.815 980H416.548Z",
    fill: "url(#paint53_linear_14_2009)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.01 980L1104.38 928.863V818.859L1199.75 763.841L1295.12 818.859V928.863L1206.51 980H1213.25L1298.5 930.838V816.918L1199.75 759.958L1101.03 816.918V930.838L1186.28 980H1193.01Z",
    fill: "url(#paint54_linear_14_2009)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.87 763.841L1440 790.446V786.564L1393.87 759.958L1295.12 816.918V930.838L1380.41 980H1387.14L1298.5 928.863V818.859L1393.87 763.841Z",
    fill: "url(#paint55_linear_14_2009)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 957.276L1400.61 980H1407.34L1440 961.192V957.276Z",
    fill: "url(#paint56_linear_14_2009)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 956.741V960.623L21.5992 980H28.3324L-12 956.741Z",
    fill: "url(#paint57_linear_14_2009)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5321 980L132.111 931.808L215.69 980H222.457L132.111 927.893L41.7988 980H48.5321Z",
    fill: "url(#paint58_linear_14_2009)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M242.657 980L326.236 931.808L409.815 980H416.549L326.236 927.893L235.924 980H242.657Z",
    fill: "url(#paint59_linear_14_2009)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M436.782 980L520.361 931.808L603.94 980H610.673L520.361 927.893L430.048 980H436.782Z",
    fill: "url(#paint60_linear_14_2009)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M630.906 980L714.486 931.808L798.031 980H804.798L714.486 927.893L624.14 980H630.906Z",
    fill: "url(#paint61_linear_14_2009)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M824.998 980L908.577 931.808L992.156 980H998.889L908.577 927.893L818.265 980H824.998Z",
    fill: "url(#paint62_linear_14_2009)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.12 980L1102.7 931.808L1186.28 980H1193.01L1102.7 927.893L1012.39 980H1019.12Z",
    fill: "url(#paint63_linear_14_2009)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.25 980L1296.83 931.808L1380.41 980H1387.14L1296.83 927.893L1206.51 980H1213.25Z",
    fill: "url(#paint64_linear_14_2009)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 957.276L1400.61 980H1407.34L1440 961.192V957.276Z",
    fill: "url(#paint65_linear_14_2009)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 163.621C233.11 163.621 235.522 161.212 235.522 158.267C235.522 155.322 233.11 152.912 230.162 152.912C227.214 152.912 224.802 155.322 224.802 158.267C224.802 161.212 227.214 163.621 230.162 163.621Z",
    fill: "url(#paint66_linear_14_2009)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M751.468 19.1475C745.807 19.1475 741.184 23.7324 741.184 29.4216C741.184 35.1109 745.773 39.6958 751.468 39.6958C757.163 39.6958 761.752 35.1109 761.752 29.4216C761.752 23.7324 757.163 19.1475 751.468 19.1475Z",
    fill: "url(#paint67_linear_14_2009)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M751.468 121.755C755.019 121.755 757.9 118.877 757.9 115.329C757.9 111.782 755.019 108.904 751.468 108.904C747.918 108.904 745.037 111.782 745.037 115.329C745.037 118.877 747.918 121.755 751.468 121.755Z",
    fill: "url(#paint68_linear_14_2009)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M825.936 164.056C829.118 164.056 831.731 161.479 831.731 158.267C831.731 155.054 829.152 152.477 825.936 152.477C822.72 152.477 820.141 155.054 820.141 158.267C820.141 161.479 822.72 164.056 825.936 164.056Z",
    fill: "url(#paint69_linear_14_2009)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M900.404 35.3114C903.653 35.3114 906.299 32.6676 906.299 29.4213C906.299 26.1751 903.653 23.5312 900.404 23.5312C897.154 23.5312 894.508 26.1751 894.508 29.4213C894.508 32.6676 897.154 35.3114 900.404 35.3114Z",
    fill: "url(#paint70_linear_14_2009)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M900.403 104.988C894.675 104.988 890.052 109.607 890.052 115.329C890.052 121.052 894.675 125.671 900.403 125.671C906.132 125.671 910.754 121.052 910.754 115.329C910.754 109.607 906.132 104.988 900.403 104.988Z",
    fill: "url(#paint71_linear_14_2009)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 37.4535C1053.76 37.4535 1057.38 33.8726 1057.38 29.4216C1057.38 24.9705 1053.79 21.3896 1049.34 21.3896C1044.88 21.3896 1041.3 24.9705 1041.3 29.4216C1041.3 33.8726 1044.88 37.4535 1049.34 37.4535Z",
    fill: "url(#paint72_linear_14_2009)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 124.901C1054.63 124.901 1058.92 120.616 1058.92 115.33C1058.92 110.044 1054.63 105.758 1049.34 105.758C1044.05 105.758 1039.76 110.044 1039.76 115.33C1039.76 120.616 1044.05 124.901 1049.34 124.901Z",
    fill: "url(#paint73_linear_14_2009)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 35.1775C1201.46 35.1775 1204.04 32.6006 1204.04 29.4212C1204.04 26.2419 1201.46 23.665 1198.27 23.665C1195.09 23.665 1192.51 26.2419 1192.51 29.4212C1192.51 32.6006 1195.09 35.1775 1198.27 35.1775Z",
    fill: "url(#paint74_linear_14_2009)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 119.446C1200.55 119.446 1202.39 117.603 1202.39 115.33C1202.39 113.056 1200.55 111.213 1198.27 111.213C1196 111.213 1194.15 113.056 1194.15 115.33C1194.15 117.603 1196 119.446 1198.27 119.446Z",
    fill: "url(#paint75_linear_14_2009)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 35.5123C1350.63 35.5123 1353.34 32.7681 1353.34 29.4214C1353.34 26.0748 1350.59 23.3306 1347.24 23.3306C1343.89 23.3306 1341.15 26.0748 1341.15 29.4214C1341.15 32.7681 1343.89 35.5123 1347.24 35.5123Z",
    fill: "url(#paint76_linear_14_2009)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 122.257C1351.07 122.257 1354.18 119.155 1354.18 115.329C1354.18 111.503 1351.07 108.402 1347.24 108.402C1343.41 108.402 1340.31 111.503 1340.31 115.329C1340.31 119.155 1343.41 122.257 1347.24 122.257Z",
    fill: "url(#paint77_linear_14_2009)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 280.319C151.876 280.319 148.827 283.398 148.827 287.146C148.827 290.894 151.909 293.973 155.661 293.973C159.413 293.973 162.528 290.894 162.528 287.146C162.528 283.398 159.446 280.319 155.661 280.319Z",
    fill: "url(#paint78_linear_14_2009)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1934 248.526C83.58 248.526 85.5147 246.593 85.5147 244.209C85.5147 241.824 83.58 239.892 81.1934 239.892C78.8068 239.892 76.8721 241.824 76.8721 244.209C76.8721 246.593 78.8068 248.526 81.1934 248.526Z",
    fill: "url(#paint79_linear_14_2009)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1935 161.547C83.0024 161.547 84.4764 160.074 84.4764 158.267C84.4764 156.46 83.0024 154.987 81.1935 154.987C79.3846 154.987 77.9106 156.46 77.9106 158.267C77.9106 160.074 79.3846 161.547 81.1935 161.547Z",
    fill: "url(#paint80_linear_14_2009)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 125.336C161.193 125.336 165.677 120.856 165.677 115.33C165.677 109.803 161.193 105.323 155.661 105.323C150.129 105.323 145.645 109.803 145.645 115.33C145.645 120.856 150.129 125.336 155.661 125.336Z",
    fill: "url(#paint81_linear_14_2009)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 252.609C234.818 252.609 238.57 248.827 238.57 244.209C238.57 239.59 234.785 235.809 230.162 235.809C225.539 235.809 221.754 239.59 221.754 244.209C221.754 248.827 225.539 252.609 230.162 252.609Z",
    fill: "url(#paint82_linear_14_2009)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M825.936 251.94C830.224 251.94 833.707 248.459 833.707 244.175C833.707 239.892 830.224 236.411 825.936 236.411C821.648 236.411 818.164 239.892 818.164 244.175C818.164 248.459 821.648 251.94 825.936 251.94Z",
    fill: "url(#paint83_linear_14_2009)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M974.871 154.318C972.694 154.318 970.885 156.092 970.885 158.3C970.885 160.509 972.66 162.283 974.871 162.283C977.082 162.283 978.857 160.509 978.857 158.3C978.857 156.092 977.082 154.318 974.871 154.318Z",
    fill: "url(#paint84_linear_14_2009)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M974.871 251.571C978.924 251.571 982.24 248.292 982.24 244.209C982.24 240.126 978.958 236.846 974.871 236.846C970.784 236.846 967.501 240.126 967.501 244.209C967.501 248.292 970.784 251.571 974.871 251.571Z",
    fill: "url(#paint85_linear_14_2009)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 291.798C1051.91 291.798 1053.99 289.715 1053.99 287.146C1053.99 284.577 1051.91 282.494 1049.34 282.494C1046.77 282.494 1044.68 284.577 1044.68 287.146C1044.68 289.715 1046.77 291.798 1049.34 291.798Z",
    fill: "url(#paint86_linear_14_2009)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 147.424C1117.81 147.424 1112.92 152.276 1112.92 158.3C1112.92 164.324 1117.78 169.177 1123.81 169.177C1129.84 169.177 1134.69 164.324 1134.69 158.3C1134.69 152.276 1129.84 147.424 1123.81 147.424Z",
    fill: "url(#paint87_linear_14_2009)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 166.366C1277.23 166.366 1280.85 162.751 1280.85 158.3C1280.85 153.849 1277.23 150.235 1272.77 150.235C1268.32 150.235 1264.7 153.849 1264.7 158.3C1264.7 162.751 1268.32 166.366 1272.77 166.366Z",
    fill: "url(#paint88_linear_14_2009)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 295.178C1351.7 295.178 1355.28 291.563 1355.28 287.146C1355.28 282.728 1351.66 279.114 1347.24 279.114C1342.82 279.114 1339.2 282.728 1339.2 287.146C1339.2 291.563 1342.82 295.178 1347.24 295.178Z",
    fill: "url(#paint89_linear_14_2009)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 253.68C1278 253.68 1282.25 249.43 1282.25 244.209C1282.25 238.988 1278 234.738 1272.77 234.738C1267.55 234.738 1263.29 238.988 1263.29 244.209C1263.29 249.43 1267.55 253.68 1272.77 253.68Z",
    fill: "url(#paint90_linear_14_2009)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 166.901C1426.47 166.901 1430.35 163.053 1430.35 158.267C1430.35 153.481 1426.5 149.633 1421.71 149.633C1416.92 149.633 1413.07 153.481 1413.07 158.267C1413.07 163.053 1416.92 166.901 1421.71 166.901Z",
    fill: "url(#paint91_linear_14_2009)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M906.601 287.146C906.601 283.732 903.82 280.955 900.403 280.955C896.986 280.955 894.206 283.732 894.206 287.146C894.206 290.559 896.986 293.337 900.403 293.337C903.82 293.337 906.601 290.559 906.601 287.146Z",
    fill: "url(#paint92_linear_14_2009)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 249.195C1126.56 249.195 1128.8 246.963 1128.8 244.209C1128.8 241.455 1126.56 239.222 1123.81 239.222C1121.05 239.222 1118.81 241.455 1118.81 244.209C1118.81 246.963 1121.05 249.195 1123.81 249.195Z",
    fill: "url(#paint93_linear_14_2009)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 292.501C1201.22 292.501 1203.63 290.125 1203.63 287.146C1203.63 284.168 1201.26 281.792 1198.27 281.792C1195.29 281.792 1192.91 284.168 1192.91 287.146C1192.91 290.125 1195.29 292.501 1198.27 292.501Z",
    fill: "url(#paint94_linear_14_2009)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 421.313C1424.63 421.313 1427 418.945 1427 416.025C1427 413.105 1424.63 410.737 1421.71 410.737C1418.79 410.737 1416.42 413.105 1416.42 416.025C1416.42 418.945 1418.79 421.313 1421.71 421.313Z",
    fill: "url(#paint95_linear_14_2009)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 366.16C1343.42 366.16 1340.34 369.239 1340.34 373.054C1340.34 376.869 1343.42 379.948 1347.24 379.948C1351.06 379.948 1354.14 376.869 1354.14 373.054C1354.14 369.239 1351.06 366.16 1347.24 366.16Z",
    fill: "url(#paint96_linear_14_2009)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 250.801C1425.35 250.801 1428.31 247.85 1428.31 244.209C1428.31 240.567 1425.35 237.616 1421.71 237.616C1418.06 237.616 1415.11 240.567 1415.11 244.209C1415.11 247.85 1418.06 250.801 1421.71 250.801Z",
    fill: "url(#paint97_linear_14_2009)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 537.039C151.34 537.039 147.822 540.553 147.822 544.87C147.822 549.187 151.34 552.701 155.661 552.701C159.982 552.701 163.5 549.187 163.5 544.87C163.5 540.553 159.982 537.039 155.661 537.039Z",
    fill: "url(#paint98_linear_14_2009)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1932 502.636C81.5817 502.636 81.8967 502.321 81.8967 501.933C81.8967 501.545 81.5817 501.23 81.1932 501.23C80.8047 501.23 80.4897 501.545 80.4897 501.933C80.4897 502.321 80.8047 502.636 81.1932 502.636Z",
    fill: "url(#paint99_linear_14_2009)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1934 422.283C84.6531 422.283 87.4577 419.481 87.4577 416.025C87.4577 412.568 84.6531 409.767 81.1934 409.767C77.7338 409.767 74.9292 412.568 74.9292 416.025C74.9292 419.481 77.7338 422.283 81.1934 422.283Z",
    fill: "url(#paint100_linear_14_2009)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 367.666C152.679 367.666 150.268 370.076 150.268 373.054C150.268 376.033 152.679 378.442 155.661 378.442C158.642 378.442 161.054 376.033 161.054 373.054C161.054 370.076 158.642 367.666 155.661 367.666Z",
    fill: "url(#paint101_linear_14_2009)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M299.739 544.87C299.739 547.548 301.916 549.757 304.63 549.757C307.343 549.757 309.52 547.581 309.52 544.87C309.52 542.16 307.343 539.984 304.63 539.984C301.916 539.984 299.739 542.16 299.739 544.87Z",
    fill: "url(#paint102_linear_14_2009)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 365.123C1044.95 365.123 1041.37 368.67 1041.37 373.088C1041.37 377.505 1044.92 381.053 1049.34 381.053C1053.76 381.053 1057.31 377.505 1057.31 373.088C1057.31 368.67 1053.76 365.123 1049.34 365.123Z",
    fill: "url(#paint103_linear_14_2009)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.53 416.025C1115.53 420.576 1119.22 424.291 1123.81 424.291C1128.4 424.291 1132.08 420.61 1132.08 416.025C1132.08 411.44 1128.4 407.759 1123.81 407.759C1119.22 407.759 1115.53 411.44 1115.53 416.025Z",
    fill: "url(#paint104_linear_14_2009)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 549.857C1201.03 549.857 1203.26 547.624 1203.26 544.87C1203.26 542.116 1201.03 539.884 1198.27 539.884C1195.52 539.884 1193.28 542.116 1193.28 544.87C1193.28 547.624 1195.52 549.857 1198.27 549.857Z",
    fill: "url(#paint105_linear_14_2009)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 508.425C1127.4 508.425 1130.3 505.519 1130.3 501.933C1130.3 498.347 1127.4 495.44 1123.81 495.44C1120.22 495.44 1117.31 498.347 1117.31 501.933C1117.31 505.519 1120.22 508.425 1123.81 508.425Z",
    fill: "url(#paint106_linear_14_2009)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 379.982C1202.1 379.982 1205.21 376.88 1205.21 373.054C1205.21 369.228 1202.1 366.126 1198.27 366.126C1194.44 366.126 1191.34 369.228 1191.34 373.054C1191.34 376.88 1194.44 379.982 1198.27 379.982Z",
    fill: "url(#paint107_linear_14_2009)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 511.772C1278.21 511.772 1282.62 507.367 1282.62 501.933C1282.62 496.499 1278.21 492.094 1272.77 492.094C1267.34 492.094 1262.93 496.499 1262.93 501.933C1262.93 507.367 1267.34 511.772 1272.77 511.772Z",
    fill: "url(#paint108_linear_14_2009)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 550.459C1350.32 550.459 1352.8 547.983 1352.8 544.904C1352.8 541.825 1350.32 539.349 1347.24 539.349C1344.16 539.349 1341.68 541.825 1341.68 544.904C1341.68 547.983 1344.16 550.459 1347.24 550.459Z",
    fill: "url(#paint109_linear_14_2009)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 425.764C1278.17 425.764 1282.52 421.413 1282.52 416.025C1282.52 410.637 1278.17 406.286 1272.77 406.286C1267.38 406.286 1263.03 410.637 1263.03 416.025C1263.03 421.413 1267.38 425.764 1272.77 425.764Z",
    fill: "url(#paint110_linear_14_2009)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 506.351C1424.15 506.351 1426.13 504.373 1426.13 501.933C1426.13 499.493 1424.15 497.516 1421.71 497.516C1419.27 497.516 1417.29 499.493 1417.29 501.933C1417.29 504.373 1419.27 506.351 1421.71 506.351Z",
    fill: "url(#paint111_linear_14_2009)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 511.404C235.422 511.404 239.676 507.154 239.676 501.933C239.676 496.712 235.422 492.462 230.162 492.462C224.903 492.462 220.682 496.712 220.682 501.933C220.682 507.154 224.936 511.404 230.162 511.404Z",
    fill: "url(#paint112_linear_14_2009)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M304.63 638.844C309.085 638.844 312.703 635.23 312.703 630.779C312.703 626.328 309.085 622.713 304.63 622.713C300.174 622.713 296.557 626.328 296.557 630.779C296.557 635.23 300.174 638.844 304.63 638.844Z",
    fill: "url(#paint113_linear_14_2009)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M457.384 630.779C457.384 628.67 455.675 626.963 453.565 626.963C451.455 626.963 449.746 628.67 449.746 630.779C449.746 632.887 451.455 634.594 453.565 634.594C455.675 634.594 457.384 632.887 457.384 630.779Z",
    fill: "url(#paint114_linear_14_2009)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M528.032 681.146C532.119 681.146 535.435 677.833 535.435 673.75C535.435 669.667 532.119 666.354 528.032 666.354C523.945 666.354 520.629 669.667 520.629 673.75C520.629 677.833 523.945 681.146 528.032 681.146Z",
    fill: "url(#paint115_linear_14_2009)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M609.668 630.779C609.668 626.829 606.453 623.617 602.5 623.617C598.547 623.617 595.331 626.829 595.331 630.779C595.331 634.728 598.547 637.94 602.5 637.94C606.453 637.94 609.668 634.728 609.668 630.779Z",
    fill: "url(#paint116_linear_14_2009)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M676.967 682.116C681.59 682.116 685.342 678.368 685.342 673.749C685.342 669.131 681.59 665.383 676.967 665.383C672.345 665.383 668.593 669.131 668.593 673.749C668.593 678.368 672.345 682.116 676.967 682.116Z",
    fill: "url(#paint117_linear_14_2009)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 807.447C158.325 807.447 160.485 805.29 160.485 802.628C160.485 799.967 158.325 797.809 155.661 797.809C152.997 797.809 150.837 799.967 150.837 802.628C150.837 805.29 152.997 807.447 155.661 807.447Z",
    fill: "url(#paint118_linear_14_2009)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1937 763.506C83.3212 763.506 85.046 761.783 85.046 759.658C85.046 757.532 83.3212 755.809 81.1937 755.809C79.0661 755.809 77.3413 757.532 77.3413 759.658C77.3413 761.783 79.0661 763.506 81.1937 763.506Z",
    fill: "url(#paint119_linear_14_2009)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3848 673.749C79.3848 674.753 80.1887 675.59 81.2272 675.59C82.2656 675.59 83.0696 674.787 83.0696 673.749C83.0696 672.712 82.2656 671.909 81.2272 671.909C80.1887 671.909 79.3848 672.712 79.3848 673.749Z",
    fill: "url(#paint120_linear_14_2009)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 638.342C159.842 638.342 163.232 634.956 163.232 630.779C163.232 626.602 159.842 623.215 155.661 623.215C151.48 623.215 148.09 626.602 148.09 630.779C148.09 634.956 151.48 638.342 155.661 638.342Z",
    fill: "url(#paint121_linear_14_2009)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M223.898 759.657C223.898 763.104 226.678 765.882 230.129 765.882C233.579 765.882 236.359 763.104 236.359 759.657C236.359 756.21 233.579 753.433 230.129 753.433C226.678 753.433 223.898 756.21 223.898 759.657Z",
    fill: "url(#paint122_linear_14_2009)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M234.416 673.75C234.416 671.373 232.507 669.466 230.129 669.466C227.75 669.466 225.841 671.373 225.841 673.75C225.841 676.126 227.75 678.033 230.129 678.033C232.507 678.033 234.416 676.126 234.416 673.75Z",
    fill: "url(#paint123_linear_14_2009)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M379.097 670.235C377.154 670.235 375.58 671.808 375.58 673.749C375.58 675.69 377.154 677.263 379.097 677.263C381.04 677.263 382.614 675.69 382.614 673.749C382.614 671.808 381.04 670.235 379.097 670.235Z",
    fill: "url(#paint124_linear_14_2009)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M447.669 802.628C447.669 805.875 450.315 808.519 453.565 808.519C456.814 808.519 459.46 805.875 459.46 802.628C459.46 799.382 456.814 796.738 453.565 796.738C450.315 796.738 447.669 799.382 447.669 802.628Z",
    fill: "url(#paint125_linear_14_2009)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M379.097 751.157C374.407 751.157 370.588 754.972 370.588 759.658C370.588 764.343 374.407 768.158 379.097 768.158C383.787 768.158 387.606 764.343 387.606 759.658C387.606 754.972 383.787 751.157 379.097 751.157Z",
    fill: "url(#paint126_linear_14_2009)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M676.967 768.827C682.026 768.827 686.146 764.711 686.146 759.658C686.146 754.604 682.026 750.488 676.967 750.488C671.909 750.488 667.789 754.604 667.789 759.658C667.789 764.711 671.909 768.827 676.967 768.827Z",
    fill: "url(#paint127_linear_14_2009)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 798.01C1195.73 798.01 1193.68 800.051 1193.68 802.595C1193.68 805.138 1195.73 807.18 1198.27 807.18C1200.82 807.18 1202.86 805.138 1202.86 802.595C1202.86 800.051 1200.82 798.01 1198.27 798.01Z",
    fill: "url(#paint128_linear_14_2009)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 636.133C1201.22 636.133 1203.63 633.723 1203.63 630.778C1203.63 627.833 1201.22 625.424 1198.27 625.424C1195.33 625.424 1192.91 627.833 1192.91 630.778C1192.91 633.723 1195.33 636.133 1198.27 636.133Z",
    fill: "url(#paint129_linear_14_2009)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 663.274C1266.98 663.274 1262.29 667.96 1262.29 673.749C1262.29 679.539 1266.98 684.224 1272.77 684.224C1278.57 684.224 1283.26 679.539 1283.26 673.749C1283.26 667.96 1278.57 663.274 1272.77 663.274Z",
    fill: "url(#paint130_linear_14_2009)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 636.468C1350.39 636.468 1352.94 633.924 1352.94 630.779C1352.94 627.633 1350.39 625.089 1347.24 625.089C1344.09 625.089 1341.55 627.633 1341.55 630.779C1341.55 633.924 1344.09 636.468 1347.24 636.468Z",
    fill: "url(#paint131_linear_14_2009)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 682.283C1426.43 682.283 1430.25 678.468 1430.25 673.749C1430.25 669.031 1426.43 665.215 1421.71 665.215C1416.99 665.215 1413.17 669.031 1413.17 673.749C1413.17 678.468 1416.99 682.283 1421.71 682.283Z",
    fill: "url(#paint132_linear_14_2009)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 748.279C1415.41 748.279 1410.32 753.366 1410.32 759.658C1410.32 765.95 1415.41 771.036 1421.71 771.036C1428.01 771.036 1433.1 765.95 1433.1 759.658C1433.1 753.366 1428.01 748.279 1421.71 748.279Z",
    fill: "url(#paint133_linear_14_2009)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M298.968 802.628C298.968 805.741 301.481 808.284 304.63 808.284C307.778 808.284 310.291 805.774 310.291 802.628C310.291 799.483 307.778 796.973 304.63 796.973C301.481 796.973 298.968 799.483 298.968 802.628Z",
    fill: "url(#paint134_linear_14_2009)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M304.629 897.74C309.721 897.74 313.875 893.624 313.875 888.503C313.875 883.383 309.755 879.267 304.629 879.267C299.504 879.267 295.384 883.383 295.384 888.503C295.384 893.624 299.504 897.74 304.629 897.74Z",
    fill: "url(#paint135_linear_14_2009)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M528.032 769.296C533.361 769.296 537.68 764.981 537.68 759.658C537.68 754.335 533.361 750.02 528.032 750.02C522.704 750.02 518.385 754.335 518.385 759.658C518.385 764.981 522.704 769.296 528.032 769.296Z",
    fill: "url(#paint136_linear_14_2009)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 806.176C604.461 806.176 606.051 804.588 606.051 802.628C606.051 800.669 604.461 799.081 602.5 799.081C600.539 799.081 598.949 800.669 598.949 802.628C598.949 804.588 600.539 806.176 602.5 806.176Z",
    fill: "url(#paint137_linear_14_2009)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M676.967 938.602C680.887 938.602 684.069 935.423 684.069 931.507C684.069 927.592 680.887 924.413 676.967 924.413C673.048 924.413 669.866 927.592 669.866 931.507C669.866 935.423 673.048 938.602 676.967 938.602Z",
    fill: "url(#paint138_linear_14_2009)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5 899.413C608.513 899.413 613.387 894.544 613.387 888.537C613.387 882.53 608.513 877.66 602.5 877.66C596.487 877.66 591.613 882.53 591.613 888.537C591.613 894.544 596.487 899.413 602.5 899.413Z",
    fill: "url(#paint139_linear_14_2009)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.47 888.537C1204.47 885.123 1201.69 882.379 1198.27 882.379C1194.86 882.379 1192.11 885.157 1192.11 888.537C1192.11 891.917 1194.89 894.728 1198.27 894.728C1201.66 894.728 1204.47 891.95 1204.47 888.537Z",
    fill: "url(#paint140_linear_14_2009)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 810.66C1351.7 810.66 1355.28 807.046 1355.28 802.629C1355.28 798.211 1351.66 794.597 1347.24 794.597C1342.82 794.597 1339.2 798.211 1339.2 802.629C1339.2 807.046 1342.82 810.66 1347.24 810.66Z",
    fill: "url(#paint141_linear_14_2009)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 880.505C1342.79 880.505 1339.2 884.086 1339.2 888.537C1339.2 892.988 1342.79 896.569 1347.24 896.569C1351.7 896.569 1355.28 892.988 1355.28 888.537C1355.28 884.086 1351.7 880.505 1347.24 880.505Z",
    fill: "url(#paint142_linear_14_2009)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6338 931.474C82.6338 930.704 81.9973 930.035 81.1934 930.035C80.3894 930.035 79.7529 930.671 79.7529 931.474C79.7529 932.277 80.3894 932.913 81.1934 932.913C81.9973 932.913 82.6338 932.277 82.6338 931.474Z",
    fill: "url(#paint143_linear_14_2009)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 883.885C153.082 883.885 151.005 885.96 151.005 888.537C151.005 891.114 153.082 893.188 155.661 893.188C158.241 893.188 160.318 891.114 160.318 888.537C160.318 885.96 158.241 883.885 155.661 883.885Z",
    fill: "url(#paint144_linear_14_2009)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 919.627C223.63 919.627 218.304 924.915 218.304 931.474C218.304 938.033 223.597 943.321 230.162 943.321C236.728 943.321 242.021 938.033 242.021 931.474C242.021 924.915 236.728 919.627 230.162 919.627Z",
    fill: "url(#paint145_linear_14_2009)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M379.097 924.312C375.145 924.312 371.929 927.525 371.929 931.474C371.929 935.423 375.145 938.636 379.097 938.636C383.05 938.636 386.266 935.423 386.266 931.474C386.266 927.525 383.05 924.312 379.097 924.312Z",
    fill: "url(#paint146_linear_14_2009)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M453.565 896.669C458.054 896.669 461.705 893.021 461.705 888.537C461.705 884.052 458.054 880.404 453.565 880.404C449.076 880.404 445.425 884.052 445.425 888.537C445.425 893.021 449.076 896.669 453.565 896.669Z",
    fill: "url(#paint147_linear_14_2009)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M537.345 931.474C537.345 926.32 533.158 922.17 528.032 922.17C522.907 922.17 518.72 926.354 518.72 931.474C518.72 936.594 522.907 940.778 528.032 940.778C533.158 940.778 537.345 936.594 537.345 931.474Z",
    fill: "url(#paint148_linear_14_2009)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 937.866C1127.32 937.866 1130.2 934.988 1130.2 931.474C1130.2 927.96 1127.32 925.082 1123.81 925.082C1120.29 925.082 1117.41 927.96 1117.41 931.474C1117.41 934.988 1120.26 937.866 1123.81 937.866Z",
    fill: "url(#paint149_linear_14_2009)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 938.535C1276.69 938.535 1279.84 935.356 1279.84 931.474C1279.84 927.592 1276.66 924.413 1272.77 924.413C1268.89 924.413 1265.71 927.592 1265.71 931.474C1265.71 935.356 1268.89 938.535 1272.77 938.535Z",
    fill: "url(#paint150_linear_14_2009)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 149.298L1091.31 149.197L1000.23 96.6551V-8.66355L1000.43 -8.76396L1091.51 -61.3062L1091.71 -61.2058L1182.8 -8.66355V96.6551L1182.6 96.7555L1091.51 149.298ZM1001 96.1866L1091.51 148.394L1182.03 96.1866V-8.22849L1091.51 -60.436L1001 -8.22849V96.1866Z",
    fill: "url(#paint151_linear_14_2009)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 149.298L1273.11 149.197L1182.03 96.6551V-8.66355L1182.23 -8.76396L1273.31 -61.3062L1273.51 -61.2058L1364.59 -8.66355V96.6551L1364.39 96.7555L1273.31 149.298ZM1182.8 96.1866L1273.31 148.394L1363.82 96.1866V-8.22849L1273.31 -60.436L1182.8 -8.22849V96.1866Z",
    fill: "url(#paint152_linear_14_2009)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 129.151L1364.59 96.1864V-8.22872L1421.74 -41.1931V-42.0967L1363.99 -8.79764L1363.79 -8.66377V96.6214L1421.74 130.054V129.151Z",
    fill: "url(#paint153_linear_14_2009)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 306.59L1182.19 306.489L1091.11 253.947V148.628L1091.31 148.528L1182.4 95.9858L1182.6 96.0862L1273.68 148.628V253.947L1273.48 254.048L1182.4 306.59ZM1091.92 253.479L1182.43 305.686L1272.94 253.479V149.064L1182.43 96.856L1091.92 149.064V253.479Z",
    fill: "url(#paint154_linear_14_2009)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 272.487L1364.19 305.652L1273.71 253.478V149.063L1364.19 96.8558L1421.74 130.054V129.151L1364.39 96.0526L1364.19 95.9521L1273.11 148.494L1272.91 148.595V253.913L1363.99 306.456L1364.19 306.589L1421.74 273.391V272.487Z",
    fill: "url(#paint155_linear_14_2009)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0.963986 253.345L0.762994 253.244L-12 260.607V261.51L0.762994 254.148L91.2429 306.355V410.737L0.762994 462.944L-12 455.582V456.519L0.562003 463.748L0.762994 463.848L91.8459 411.306L92.0469 411.205V305.887L0.963986 253.345Z",
    fill: "url(#paint156_linear_14_2009)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 463.848L1273.11 463.748L1182.03 411.205V305.887L1182.23 305.786L1273.31 253.244L1273.51 253.345L1364.59 305.887V411.205L1364.39 411.306L1273.31 463.848ZM1182.8 410.737L1273.31 462.944L1363.82 410.737V306.322L1273.31 254.114L1182.8 306.322V410.737Z",
    fill: "url(#paint157_linear_14_2009)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 443.701L1364.59 410.737V306.355L1421.74 273.391V272.487L1363.99 305.786L1363.79 305.887V411.205L1421.74 444.638V443.701Z",
    fill: "url(#paint158_linear_14_2009)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 455.582V456.519L0.361011 463.647V568.029L-12 575.157V576.094L0.963986 568.598L1.16498 568.498V463.179L-12 455.582Z",
    fill: "url(#paint159_linear_14_2009)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6447 621.14L91.4437 621.04L0.36084 568.497V463.179L0.561832 463.078L91.6447 410.536L91.8457 410.637L182.929 463.179V568.497L182.728 568.598L91.6447 621.14ZM1.16481 568.029L91.6782 620.236L182.192 568.029V463.614L91.6782 411.406L1.16481 463.614V568.029Z",
    fill: "url(#paint160_linear_14_2009)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M273.442 621.14L273.241 621.04L182.158 568.497V463.179L182.359 463.078L273.442 410.536L273.643 410.637L364.726 463.179V568.497L364.525 568.598L273.442 621.14ZM182.929 568.029L273.442 620.236L363.956 568.029V463.614L273.442 411.406L182.929 463.614V568.029Z",
    fill: "url(#paint161_linear_14_2009)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M455.239 621.14L455.038 621.04L363.956 568.497V463.179L364.157 463.078L455.239 410.536L455.44 410.637L546.523 463.179V568.497L546.322 568.598L455.239 621.14ZM364.726 568.029L455.239 620.236L545.753 568.029V463.614L455.239 411.406L364.726 463.614V568.029Z",
    fill: "url(#paint162_linear_14_2009)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0.963986 567.929L0.762994 567.795L-12 575.158V576.095L0.762994 568.732L91.2429 620.906V725.321L0.762994 777.529L-12 770.166V771.07L0.562003 778.332L0.762994 778.432L91.8459 725.89L92.0469 725.79V620.471L0.963986 567.929Z",
    fill: "url(#paint163_linear_14_2009)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56 778.432L182.359 778.332L91.2764 725.789V620.471L91.4774 620.37L182.56 567.828L182.761 567.929L273.844 620.471V725.789L273.643 725.89L182.56 778.432ZM92.0468 725.321L182.56 777.528L273.074 725.321V620.906L182.56 568.698L92.0468 620.906V725.321Z",
    fill: "url(#paint164_linear_14_2009)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M364.324 778.432L364.123 778.332L273.04 725.789V620.471L273.241 620.37L364.324 567.828L364.525 567.929L455.608 620.471V725.789L455.407 725.89L364.324 778.432ZM273.844 725.321L364.357 777.528L454.871 725.321V620.906L364.357 568.698L273.844 620.906V725.321Z",
    fill: "url(#paint165_linear_14_2009)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 770.166V771.07L0.361011 778.198V882.613L-12 889.741V890.645L0.963986 883.182L1.16498 883.082V777.763L-12 770.166Z",
    fill: "url(#paint166_linear_14_2009)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6447 935.724L91.4437 935.624L0.36084 883.081V777.763L0.561832 777.662L91.6447 725.12L91.8457 725.221L182.929 777.763V883.081L182.728 883.182L91.6447 935.724ZM1.16481 882.613L91.6782 934.82L182.192 882.613V778.198L91.6782 725.99L1.16481 778.198V882.613Z",
    fill: "url(#paint167_linear_14_2009)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M273.442 935.724L273.241 935.624L182.158 883.081V777.763L182.359 777.662L273.442 725.12L273.643 725.221L364.726 777.763V883.081L364.525 883.182L273.442 935.724ZM182.929 882.613L273.442 934.82L363.956 882.613V778.198L273.442 725.99L182.929 778.198V882.613Z",
    fill: "url(#paint168_linear_14_2009)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M455.239 935.724L455.038 935.624L363.956 883.081V777.763L364.157 777.662L455.239 725.12L455.44 725.221L546.523 777.763V883.081L546.322 883.182L455.239 935.724ZM364.726 882.613L455.239 934.82L545.753 882.613V778.198L455.239 725.99L364.726 778.198V882.613Z",
    fill: "url(#paint169_linear_14_2009)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 935.724L1182.19 935.624L1091.11 883.081V777.763L1091.31 777.662L1182.4 725.12L1182.6 725.221L1273.68 777.763V883.081L1273.48 883.182L1182.4 935.724ZM1091.92 882.613L1182.43 934.82L1272.94 882.613V778.198L1182.43 725.99L1091.92 778.198V882.613Z",
    fill: "url(#paint170_linear_14_2009)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 901.622L1364.19 934.82L1273.71 882.613V778.198L1364.19 726.023L1421.74 759.189V758.285L1364.39 725.22L1364.19 725.086L1273.11 777.629L1272.91 777.763V883.081L1363.99 935.623L1364.19 935.724L1421.74 902.525V901.622Z",
    fill: "url(#paint171_linear_14_2009)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0.963986 882.479L0.762994 882.378L-12 889.741V890.645L0.762994 883.282L91.2429 935.49V965.777H92.0469V935.021L0.963986 882.479Z",
    fill: "url(#paint172_linear_14_2009)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0466 965.777V935.49L182.56 883.282L273.04 935.49V965.777H273.844V935.021L182.728 882.479L182.56 882.378L91.4437 934.921L91.2427 935.021V965.777H92.0466Z",
    fill: "url(#paint173_linear_14_2009)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M273.844 965.777V935.49L364.324 883.282L454.837 935.49V965.777H455.641V935.021L364.525 882.479L364.324 882.378L273.241 934.921L273.04 935.021V965.777H273.844Z",
    fill: "url(#paint174_linear_14_2009)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M455.641 965.777V935.49L546.121 883.282L636.635 935.49V965.777H637.439V935.021L546.322 882.479L546.121 882.378L455.038 934.921L454.837 935.021V965.777H455.641Z",
    fill: "url(#paint175_linear_14_2009)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.8 965.777V935.49L1273.31 883.282L1363.79 935.49V965.777H1364.59V935.021L1273.51 882.479L1273.31 882.378L1182.23 934.921L1182.03 935.021V965.777H1182.8Z",
    fill: "url(#paint176_linear_14_2009)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 901.622L1363.99 934.921L1363.79 935.021V965.777H1364.59V935.49L1421.74 902.525V901.622Z",
    fill: "url(#paint177_linear_14_2009)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.61 -152V-45.1419L1184.2 21.9917L1067.8 -45.1419V-152H1063.68V-42.7658L1184.2 26.7439L1304.73 -42.7658V-152H1300.61Z",
    fill: "url(#paint178_linear_14_2009)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.73 -45.1419V-152H1300.61V-42.7658L1421.14 26.7439L1421.74 26.4092V21.657L1421.14 21.9917L1304.73 -45.1419Z",
    fill: "url(#paint179_linear_14_2009)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 15.332V20.0842L-2.48638 25.5727V159.84L-12 165.328V170.081L1.63396 162.216V23.1966L-12 15.332Z",
    fill: "url(#paint180_linear_14_2009)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M118.042 231.726L-2.48633 162.216V23.1967L118.042 -46.313L238.57 23.1967V162.216L118.042 231.726ZM1.63401 159.84L118.042 226.973L234.45 159.84V25.5393L118.042 -41.5942L1.63401 25.5728V159.873V159.84Z",
    fill: "url(#paint181_linear_14_2009)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 21.6572L1419.06 23.1967V162.216L1421.74 163.755V21.6572Z",
    fill: "url(#paint182_linear_14_2009)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.409459 158.668L-12 165.328V170.08L-0.409459 163.421L115.965 230.554V364.821L-0.409459 431.988L-12 425.295V430.047L-0.409459 436.707L120.085 367.197V228.178L-0.409459 158.668Z",
    fill: "url(#paint183_linear_14_2009)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M236.493 436.707L115.965 367.197V228.178L236.493 158.668L357.021 228.178V367.197L236.493 436.707ZM120.085 364.821L236.493 431.955L352.901 364.821V230.521L236.493 163.387L120.085 230.521V364.821Z",
    fill: "url(#paint184_linear_14_2009)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 425.295V430.047L-2.48638 435.536V569.836L-12 575.325V580.043L1.63396 572.179V433.16L-12 425.295Z",
    fill: "url(#paint185_linear_14_2009)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M118.042 641.722L-2.48633 572.179V433.16L118.042 363.65L238.57 433.16V572.179L118.042 641.689V641.722ZM1.63401 569.836L118.042 636.97L234.45 569.836V435.536L118.042 368.402L1.63401 435.536V569.836Z",
    fill: "url(#paint186_linear_14_2009)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 432.323L1302.66 363.65L1182.13 433.16V572.179L1302.66 641.689L1421.74 573.016V432.323ZM1302.66 636.97L1186.25 569.836V435.536L1302.66 368.402L1419.06 435.536V569.836L1302.66 636.97Z",
    fill: "url(#paint187_linear_14_2009)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.409459 568.631L-12 575.325V580.043L-0.409459 573.384L115.965 640.517V774.818L-0.409459 841.951L-12 835.258V840.01L-0.409459 846.703L120.085 777.194V638.141L-0.409459 568.631Z",
    fill: "url(#paint188_linear_14_2009)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M236.493 846.704L115.965 777.194V638.175L236.493 568.665L357.021 638.175V777.194L236.493 846.704ZM120.085 774.818L236.493 841.951L352.901 774.818V640.517L236.493 573.384L120.085 640.517V774.818Z",
    fill: "url(#paint189_linear_14_2009)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.2 846.704L1063.68 777.194V638.175L1184.2 568.665L1304.73 638.175V777.194L1184.2 846.704ZM1067.8 774.818L1184.2 841.951L1300.61 774.818V640.517L1184.2 573.384L1067.8 640.517V774.818Z",
    fill: "url(#paint190_linear_14_2009)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 841.583L1421.14 841.951L1304.73 774.818V640.517L1421.14 573.384L1421.74 573.718V568.999L1421.14 568.631L1300.61 638.141V777.194L1421.14 846.703L1421.74 846.335V841.583Z",
    fill: "url(#paint191_linear_14_2009)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 835.258V840.01L-2.48638 845.499V965.777H1.63396V843.122L-12 835.258Z",
    fill: "url(#paint192_linear_14_2009)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63401 965.777V845.499L118.042 778.365L234.45 845.499V965.777H238.57V843.123L118.042 773.613L-2.48633 843.123V965.777H1.63401Z",
    fill: "url(#paint193_linear_14_2009)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.57 965.777V845.499L354.978 778.365L471.386 845.499V965.777H475.473V843.123L354.978 773.613L234.45 843.123V965.777H238.57Z",
    fill: "url(#paint194_linear_14_2009)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M475.473 965.777V845.499L591.88 778.365L708.288 845.499V965.777H712.409V843.123L591.88 773.613L471.386 843.123V965.777H475.473Z",
    fill: "url(#paint195_linear_14_2009)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M712.409 965.777V845.499L828.817 778.365L945.225 845.499V965.777H949.345V843.123L828.817 773.613L708.289 843.123V965.777H712.409Z",
    fill: "url(#paint196_linear_14_2009)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M949.345 965.777V845.499L1065.75 778.365L1182.16 845.499V965.777H1186.25V843.123L1065.75 773.613L945.225 843.123V965.777H949.345Z",
    fill: "url(#paint197_linear_14_2009)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 965.777V842.286L1302.66 773.613L1182.16 843.123V965.777H1186.25V845.499L1302.66 778.365L1419.06 845.499V965.777H1421.74Z",
    fill: "url(#paint198_linear_14_2009)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 841.583L1419.06 843.122V965.777H1421.74V841.583Z",
    fill: "url(#paint199_linear_14_2009)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 1.37643C1369.62 1.37643 1374.01 -3.00766 1374.01 -8.42922C1374.01 -13.8508 1369.62 -18.2349 1364.19 -18.2349C1358.77 -18.2349 1354.38 -13.8508 1354.38 -8.42922C1354.38 -3.00766 1358.77 1.37643 1364.19 1.37643Z",
    fill: "url(#paint200_linear_14_2009)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 88.021C1359.54 88.021 1355.78 91.7692 1355.78 96.4211C1355.78 101.073 1359.54 104.821 1364.19 104.821C1368.85 104.821 1372.6 101.073 1372.6 96.4211C1372.6 91.7692 1368.85 88.021 1364.19 88.021Z",
    fill: "url(#paint201_linear_14_2009)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6821 306.122C85.6821 309.401 88.362 312.079 91.6449 312.079C94.9278 312.079 97.6077 309.401 97.6077 306.122C97.6077 302.842 94.9278 300.165 91.6449 300.165C88.362 300.165 85.6821 302.842 85.6821 306.122Z",
    fill: "url(#paint202_linear_14_2009)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.63 106.126C1006 106.126 1010.35 101.781 1010.35 96.4211C1010.35 91.061 1006 86.7158 1000.63 86.7158C995.266 86.7158 990.917 91.061 990.917 96.4211C990.917 101.781 995.266 106.126 1000.63 106.126Z",
    fill: "url(#paint203_linear_14_2009)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.43 148.829C1081.43 154.385 1085.95 158.903 1091.51 158.903C1097.07 158.903 1101.6 154.385 1101.6 148.829C1101.6 143.274 1097.07 138.756 1091.51 138.756C1085.95 138.756 1081.43 143.274 1081.43 148.829Z",
    fill: "url(#paint204_linear_14_2009)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 312.212C1185.76 312.212 1188.49 309.485 1188.49 306.121C1188.49 302.757 1185.76 300.03 1182.4 300.03C1179.03 300.03 1176.3 302.757 1176.3 306.121C1176.3 309.485 1179.03 312.212 1182.4 312.212Z",
    fill: "url(#paint205_linear_14_2009)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 245.748C1087.13 245.748 1083.57 249.295 1083.57 253.68C1083.57 258.064 1087.13 261.611 1091.51 261.611C1095.9 261.611 1099.45 258.064 1099.45 253.68C1099.45 249.295 1095.9 245.748 1091.51 245.748Z",
    fill: "url(#paint206_linear_14_2009)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 104.888C1187.08 104.888 1190.87 101.097 1190.87 96.4211C1190.87 91.7449 1187.08 87.9541 1182.4 87.9541C1177.71 87.9541 1173.92 91.7449 1173.92 96.4211C1173.92 101.097 1177.71 104.888 1182.4 104.888Z",
    fill: "url(#paint207_linear_14_2009)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 265.694C1279.95 265.694 1285.34 260.315 1285.34 253.679C1285.34 247.044 1279.95 241.665 1273.31 241.665C1266.67 241.665 1261.28 247.044 1261.28 253.679C1261.28 260.315 1266.67 265.694 1273.31 265.694Z",
    fill: "url(#paint208_linear_14_2009)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 312.915C1367.94 312.915 1370.99 309.87 1370.99 306.121C1370.99 302.373 1367.94 299.328 1364.19 299.328C1360.44 299.328 1357.39 302.373 1357.39 306.121C1357.39 309.87 1360.44 312.915 1364.19 312.915Z",
    fill: "url(#paint209_linear_14_2009)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 160.744C1279.88 160.744 1285.2 155.422 1285.2 148.863C1285.2 142.304 1279.88 136.982 1273.31 136.982C1266.74 136.982 1261.42 142.304 1261.42 148.863C1261.42 155.422 1266.74 160.744 1273.31 160.744Z",
    fill: "url(#paint210_linear_14_2009)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0.762904 265.259C7.16115 265.259 12.3534 260.072 12.3534 253.679C12.3534 247.287 7.16115 242.1 0.762904 242.1C-5.63534 242.1 -10.8276 247.287 -10.8276 253.679C-10.8276 260.072 -5.63534 265.259 0.762904 265.259Z",
    fill: "url(#paint211_linear_14_2009)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M91.645 420.811C97.0718 420.811 101.494 416.393 101.494 410.971C101.494 405.55 97.0718 401.132 91.645 401.132C86.2182 401.132 81.7964 405.55 81.7964 410.971C81.7964 416.393 86.2182 420.811 91.645 420.811Z",
    fill: "url(#paint212_linear_14_2009)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M278.132 410.971C278.132 408.394 276.022 406.286 273.442 406.286C270.863 406.286 268.752 408.394 268.752 410.971C268.752 413.548 270.863 415.657 273.442 415.657C276.022 415.657 278.132 413.548 278.132 410.971Z",
    fill: "url(#paint213_linear_14_2009)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M364.324 472.449C369.319 472.449 373.369 468.404 373.369 463.413C373.369 458.423 369.319 454.377 364.324 454.377C359.329 454.377 355.279 458.423 355.279 463.413C355.279 468.404 359.329 472.449 364.324 472.449Z",
    fill: "url(#paint214_linear_14_2009)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M463.982 410.972C463.982 406.152 460.063 402.237 455.239 402.237C450.415 402.237 446.496 406.152 446.496 410.972C446.496 415.791 450.415 419.706 455.239 419.706C460.063 419.706 463.982 415.791 463.982 410.972Z",
    fill: "url(#paint215_linear_14_2009)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M546.121 473.621C551.764 473.621 556.339 469.051 556.339 463.413C556.339 457.776 551.764 453.206 546.121 453.206C540.479 453.206 535.904 457.776 535.904 463.413C535.904 469.051 540.479 473.621 546.121 473.621Z",
    fill: "url(#paint216_linear_14_2009)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.87451 568.263C-6.87451 572.48 -3.45765 575.86 0.729687 575.86C4.91702 575.86 8.33388 572.447 8.33388 568.263C8.33388 564.08 4.91702 560.667 0.729687 560.667C-3.45765 560.667 -6.87451 564.08 -6.87451 568.263Z",
    fill: "url(#paint217_linear_14_2009)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9887 463.413C5.9887 460.535 3.64379 458.192 0.762902 458.192C-2.11798 458.192 -4.46289 460.535 -4.46289 463.413C-4.46289 466.291 -2.11798 468.634 0.762902 468.634C3.64379 468.634 5.9887 466.291 5.9887 463.413Z",
    fill: "url(#paint218_linear_14_2009)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56 467.697C184.928 467.697 186.848 465.779 186.848 463.413C186.848 461.047 184.928 459.129 182.56 459.129C180.192 459.129 178.272 461.047 178.272 463.413C178.272 465.779 180.192 467.697 182.56 467.697Z",
    fill: "url(#paint219_linear_14_2009)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M266.24 620.705C266.24 624.688 269.456 627.9 273.442 627.9C277.428 627.9 280.644 624.688 280.644 620.705C280.644 616.723 277.428 613.51 273.442 613.51C269.456 613.51 266.24 616.723 266.24 620.705Z",
    fill: "url(#paint220_linear_14_2009)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56 557.922C176.832 557.922 172.176 562.574 172.176 568.297C172.176 574.02 176.832 578.672 182.56 578.672C188.289 578.672 192.945 574.02 192.945 568.297C192.945 562.574 188.289 557.922 182.56 557.922Z",
    fill: "url(#paint221_linear_14_2009)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M546.121 579.441C552.3 579.441 557.31 574.437 557.31 568.264C557.31 562.09 552.3 557.086 546.121 557.086C539.942 557.086 534.933 562.09 534.933 568.264C534.933 574.437 539.942 579.441 546.121 579.441Z",
    fill: "url(#paint222_linear_14_2009)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 615.083C1179.31 615.083 1176.8 617.593 1176.8 620.672C1176.8 623.751 1179.31 626.261 1182.4 626.261C1185.48 626.261 1187.99 623.751 1187.99 620.672C1187.99 617.593 1185.48 615.083 1182.4 615.083Z",
    fill: "url(#paint223_linear_14_2009)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 417.497C1186 417.497 1188.93 414.575 1188.93 410.971C1188.93 407.367 1186 404.445 1182.4 404.445C1178.79 404.445 1175.86 407.367 1175.86 410.971C1175.86 414.575 1178.79 417.497 1182.4 417.497Z",
    fill: "url(#paint224_linear_14_2009)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 476.197C1280.38 476.197 1286.11 470.474 1286.11 463.413C1286.11 456.353 1280.38 450.629 1273.31 450.629C1266.24 450.629 1260.51 456.353 1260.51 463.413C1260.51 470.474 1266.24 476.197 1273.31 476.197Z",
    fill: "url(#paint225_linear_14_2009)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 417.933C1368.04 417.933 1371.13 414.82 1371.13 411.005C1371.13 407.19 1368.01 404.078 1364.19 404.078C1360.37 404.078 1357.26 407.19 1357.26 411.005C1357.26 414.82 1360.37 417.933 1364.19 417.933Z",
    fill: "url(#paint226_linear_14_2009)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6449 627.599C95.456 627.599 98.5456 624.513 98.5456 620.705C98.5456 616.898 95.456 613.811 91.6449 613.811C87.8337 613.811 84.7441 616.898 84.7441 620.705C84.7441 624.513 87.8337 627.599 91.6449 627.599Z",
    fill: "url(#paint227_linear_14_2009)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M91.645 736.8C97.8758 736.8 102.934 731.747 102.934 725.522C102.934 719.297 97.8758 714.244 91.645 714.244C85.4143 714.244 80.356 719.297 80.356 725.522C80.356 731.747 85.4143 736.8 91.645 736.8Z",
    fill: "url(#paint228_linear_14_2009)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M364.324 580.044C370.837 580.044 376.116 574.77 376.116 568.264C376.116 561.758 370.837 556.483 364.324 556.483C357.812 556.483 352.533 561.758 352.533 568.264C352.533 574.77 357.812 580.044 364.324 580.044Z",
    fill: "url(#paint229_linear_14_2009)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M450.918 620.705C450.918 623.081 452.861 625.022 455.239 625.022C457.618 625.022 459.561 623.081 459.561 620.705C459.561 618.329 457.618 616.388 455.239 616.388C452.861 616.388 450.918 618.329 450.918 620.705Z",
    fill: "url(#paint230_linear_14_2009)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M546.121 786.665C550.913 786.665 554.798 782.784 554.798 777.997C554.798 773.21 550.913 769.329 546.121 769.329C541.33 769.329 537.445 773.21 537.445 777.997C537.445 782.784 541.33 786.665 546.121 786.665Z",
    fill: "url(#paint231_linear_14_2009)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M455.24 712.27C447.903 712.27 441.974 718.227 441.974 725.522C441.974 732.818 447.937 738.775 455.24 738.775C462.542 738.775 468.505 732.818 468.505 725.522C468.505 718.227 462.542 712.27 455.24 712.27Z",
    fill: "url(#paint232_linear_14_2009)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.97 725.555C1189.97 721.405 1186.58 718.025 1182.43 718.025C1178.27 718.025 1174.89 721.405 1174.89 725.555C1174.89 729.705 1178.27 733.085 1182.43 733.085C1186.58 733.085 1189.97 729.705 1189.97 725.555Z",
    fill: "url(#paint233_linear_14_2009)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 630.511C1369.62 630.511 1374.01 626.127 1374.01 620.705C1374.01 615.283 1369.62 610.899 1364.19 610.899C1358.77 610.899 1354.38 615.283 1354.38 620.705C1354.38 626.127 1358.77 630.511 1364.19 630.511Z",
    fill: "url(#paint234_linear_14_2009)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 715.75C1358.77 715.75 1354.38 720.134 1354.38 725.556C1354.38 730.977 1358.77 735.361 1364.19 735.361C1369.62 735.361 1374.01 730.977 1374.01 725.556C1374.01 720.134 1369.62 715.75 1364.19 715.75Z",
    fill: "url(#paint235_linear_14_2009)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0.762993 763.54C-4.79779 763.54 -9.5546 766.719 -12 771.304V784.657C-9.5881 789.242 -4.79779 792.421 0.762993 792.421C8.73568 792.421 15.2344 785.962 15.2344 777.964C15.2344 769.965 8.76917 763.506 0.762993 763.506V763.54Z",
    fill: "url(#paint236_linear_14_2009)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6448 941.514C95.0952 941.514 97.8756 938.736 97.8756 935.289C97.8756 931.842 95.0952 929.064 91.6448 929.064C88.1945 929.064 85.4141 931.842 85.4141 935.289C85.4141 938.736 88.1945 941.514 91.6448 941.514Z",
    fill: "url(#paint237_linear_14_2009)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56 895.163C189.361 895.163 194.888 889.641 194.888 882.847C194.888 876.054 189.361 870.532 182.56 870.532C175.76 870.532 170.233 876.054 170.233 882.847C170.233 889.641 175.76 895.163 182.56 895.163Z",
    fill: "url(#paint238_linear_14_2009)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M182.561 769.263C177.737 769.263 173.817 773.178 173.817 777.997C173.817 782.817 177.737 786.732 182.561 786.732C187.384 786.732 191.304 782.817 191.304 777.997C191.304 773.178 187.384 769.263 182.561 769.263Z",
    fill: "url(#paint239_linear_14_2009)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M273.442 735.495C278.936 735.495 283.391 731.044 283.391 725.555C283.391 720.067 278.936 715.616 273.442 715.616C267.948 715.616 263.493 720.067 263.493 725.555C263.493 731.044 267.948 735.495 273.442 735.495Z",
    fill: "url(#paint240_linear_14_2009)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M375.714 777.997C375.714 771.739 370.622 766.652 364.358 766.652C358.093 766.652 353.001 771.739 353.001 777.997C353.001 784.256 358.093 789.343 364.358 789.343C370.622 789.343 375.714 784.256 375.714 777.997Z",
    fill: "url(#paint241_linear_14_2009)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M455.24 944.191C460.164 944.191 464.184 940.209 464.184 935.256C464.184 930.303 460.197 926.32 455.24 926.32C450.282 926.32 446.295 930.303 446.295 935.256C446.295 940.209 450.282 944.191 455.24 944.191Z",
    fill: "url(#paint242_linear_14_2009)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M546.121 892.285C551.339 892.285 555.568 888.06 555.568 882.848C555.568 877.636 551.339 873.41 546.121 873.41C540.904 873.41 536.675 877.636 536.675 882.848C536.675 888.06 540.904 892.285 546.121 892.285Z",
    fill: "url(#paint243_linear_14_2009)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 785.795C1095.83 785.795 1099.32 782.315 1099.32 777.997C1099.32 773.68 1095.83 770.2 1091.51 770.2C1087.19 770.2 1083.71 773.68 1083.71 777.997C1083.71 782.315 1087.19 785.795 1091.51 785.795Z",
    fill: "url(#paint244_linear_14_2009)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 786.631C1278.08 786.631 1281.95 782.766 1281.95 777.997C1281.95 773.229 1278.08 769.363 1273.31 769.363C1268.54 769.363 1264.67 773.229 1264.67 777.997C1264.67 782.766 1268.54 786.631 1273.31 786.631Z",
    fill: "url(#paint245_linear_14_2009)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0.763056 878.162C-1.81634 878.162 -3.92676 880.27 -3.92676 882.847C-3.92676 885.424 -1.81634 887.533 0.763056 887.533C3.34245 887.533 5.45287 885.424 5.45287 882.847C5.45287 880.27 3.34245 878.162 0.763056 878.162Z",
    fill: "url(#paint246_linear_14_2009)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M273.442 923.476C266.943 923.476 261.65 928.763 261.65 935.256C261.65 941.748 266.943 947.036 273.442 947.036C279.941 947.036 285.233 941.748 285.233 935.256C285.233 928.763 279.941 923.476 273.442 923.476Z",
    fill: "url(#paint247_linear_14_2009)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M364.324 888.102C367.229 888.102 369.584 885.749 369.584 882.848C369.584 879.946 367.229 877.593 364.324 877.593C361.42 877.593 359.065 879.946 359.065 882.848C359.065 885.749 361.42 888.102 364.324 888.102Z",
    fill: "url(#paint248_linear_14_2009)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M637.037 942.217C640.885 942.217 644.004 939.1 644.004 935.256C644.004 931.412 640.885 928.295 637.037 928.295C633.188 928.295 630.069 931.412 630.069 935.256C630.069 939.1 633.188 942.217 637.037 942.217Z",
    fill: "url(#paint249_linear_14_2009)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 874.113C1086.69 874.113 1082.77 878.028 1082.77 882.848C1082.77 887.667 1086.69 891.582 1091.51 891.582C1096.34 891.582 1100.26 887.667 1100.26 882.848C1100.26 878.028 1096.34 874.113 1091.51 874.113Z",
    fill: "url(#paint250_linear_14_2009)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.54 935.256C1177.54 937.933 1179.72 940.142 1182.43 940.142C1185.14 940.142 1187.32 937.966 1187.32 935.256C1187.32 932.545 1185.14 930.37 1182.43 930.37C1179.72 930.37 1177.54 932.545 1177.54 935.256Z",
    fill: "url(#paint251_linear_14_2009)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 873.778C1268.29 873.778 1264.23 877.828 1264.23 882.848C1264.23 887.868 1268.29 891.917 1273.31 891.917C1278.34 891.917 1282.39 887.868 1282.39 882.848C1282.39 877.828 1278.34 873.778 1273.31 873.778Z",
    fill: "url(#paint252_linear_14_2009)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 924.513C1358.26 924.513 1353.44 929.332 1353.44 935.256C1353.44 941.179 1358.26 945.999 1364.19 945.999C1370.12 945.999 1374.95 941.179 1374.95 935.256C1374.95 929.332 1370.12 924.513 1364.19 924.513Z",
    fill: "url(#paint253_linear_14_2009)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_2009",
    x1: 897.029,
    y1: 7.91345,
    x2: 722.834,
    y2: 90.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_2009",
    x1: 1045.96,
    y1: 7.91345,
    x2: 871.769,
    y2: 90.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_2009",
    x1: 1194.9,
    y1: 7.91345,
    x2: 1020.7,
    y2: 90.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_2009",
    x1: 1343.87,
    y1: 7.91345,
    x2: 1169.67,
    y2: 90.9845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_2009",
    x1: 1437.69,
    y1: 7.88399,
    x2: 1315.41,
    y2: 44.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_2009",
    x1: 226.754,
    y1: 136.759,
    x2: 52.5594,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_2009",
    x1: 971.497,
    y1: 136.759,
    x2: 797.302,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_2009",
    x1: 1120.43,
    y1: 136.759,
    x2: 946.237,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14_2009",
    x1: 1269.37,
    y1: 136.759,
    x2: 1095.17,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14_2009",
    x1: 1418.34,
    y1: 136.759,
    x2: 1244.14,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14_2009",
    x1: 1439.54,
    y1: 160.969,
    x2: 1413.16,
    y2: 163.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14_2009",
    x1: 1194.9,
    y1: 265.638,
    x2: 1020.7,
    y2: 348.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14_2009",
    x1: 1343.87,
    y1: 265.638,
    x2: 1169.67,
    y2: 348.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14_2009",
    x1: 1437.69,
    y1: 265.609,
    x2: 1315.41,
    y2: 301.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14_2009",
    x1: 1269.37,
    y1: 394.483,
    x2: 1095.17,
    y2: 477.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14_2009",
    x1: 1418.34,
    y1: 394.483,
    x2: 1244.14,
    y2: 477.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14_2009",
    x1: 1439.54,
    y1: 418.694,
    x2: 1413.16,
    y2: 421.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14_2009",
    x1: 301.255,
    y1: 523.362,
    x2: 127.06,
    y2: 606.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14_2009",
    x1: 1343.87,
    y1: 523.362,
    x2: 1169.67,
    y2: 606.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14_2009",
    x1: 1437.69,
    y1: 523.362,
    x2: 1315.41,
    y2: 559.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14_2009",
    x1: 226.754,
    y1: 652.241,
    x2: 52.5595,
    y2: 735.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14_2009",
    x1: 375.723,
    y1: 652.241,
    x2: 201.528,
    y2: 735.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14_2009",
    x1: 524.658,
    y1: 652.241,
    x2: 350.463,
    y2: 735.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14_2009",
    x1: 673.593,
    y1: 652.241,
    x2: 499.398,
    y2: 735.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14_2009",
    x1: 1439.54,
    y1: 676.448,
    x2: 1413.16,
    y2: 678.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14_2009",
    x1: 301.255,
    y1: 781.087,
    x2: 127.06,
    y2: 864.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_14_2009",
    x1: 450.19,
    y1: 781.087,
    x2: 275.995,
    y2: 864.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_14_2009",
    x1: 599.125,
    y1: 781.087,
    x2: 424.931,
    y2: 864.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_14_2009",
    x1: 226.755,
    y1: 899.739,
    x2: 108.13,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_14_2009",
    x1: 375.69,
    y1: 899.739,
    x2: 257.065,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_14_2009",
    x1: 524.658,
    y1: 899.739,
    x2: 406.03,
    y2: 1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_14_2009",
    x1: 673.593,
    y1: 899.739,
    x2: 554.965,
    y2: 1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_14_2009",
    x1: 1269.37,
    y1: 899.739,
    x2: 1150.74,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_14_2009",
    x1: 1418.3,
    y1: 899.739,
    x2: 1299.68,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_14_2009",
    x1: 1196.56,
    y1: -51.0312,
    x2: 966.574,
    y2: 58.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_14_2009",
    x1: 1390.68,
    y1: -51.0312,
    x2: 1160.7,
    y2: 58.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_14_2009",
    x1: 1438.81,
    y1: -29.0422,
    x2: 1372.11,
    y2: -18.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_14_2009",
    x1: 1293.6,
    y1: 116.937,
    x2: 1063.62,
    y2: 226.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_14_2009",
    x1: 1436.41,
    y1: 116.966,
    x2: 1251.92,
    y2: 181.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_14_2009",
    x1: 35.5321,
    y1: 306.435,
    x2: -32.4393,
    y2: 317.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_14_2009",
    x1: 225.969,
    y1: 284.871,
    x2: -4.01611,
    y2: 394.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_14_2009",
    x1: 420.093,
    y1: 284.871,
    x2: 190.108,
    y2: 394.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_14_2009",
    x1: 1438.81,
    y1: 306.86,
    x2: 1372.11,
    y2: 317.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_14_2009",
    x1: 130.204,
    y1: 452.838,
    x2: -55.2178,
    y2: 518.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_14_2009",
    x1: 323.048,
    y1: 452.838,
    x2: 93.063,
    y2: 562.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_14_2009",
    x1: 517.139,
    y1: 452.838,
    x2: 287.154,
    y2: 562.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_14_2009",
    x1: 35.5321,
    y1: 642.332,
    x2: -32.4386,
    y2: 653.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_14_2009",
    x1: 225.969,
    y1: 620.773,
    x2: -4.01613,
    y2: 730.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_14_2009",
    x1: 420.093,
    y1: 620.773,
    x2: 190.108,
    y2: 730.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_14_2009",
    x1: 1390.68,
    y1: 620.773,
    x2: 1160.7,
    y2: 730.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_14_2009",
    x1: 27.3324,
    y1: 959.679,
    x2: -2.85114,
    y2: 988.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_14_2009",
    x1: 130.204,
    y1: 787.755,
    x2: -53.7547,
    y2: 854.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_14_2009",
    x1: 323.015,
    y1: 787.755,
    x2: 96.0861,
    y2: 899.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_14_2009",
    x1: 517.14,
    y1: 787.755,
    x2: 290.211,
    y2: 899.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_14_2009",
    x1: 1293.61,
    y1: 787.755,
    x2: 1066.68,
    y2: 899.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_14_2009",
    x1: 1436.41,
    y1: 787.755,
    x2: 1253.36,
    y2: 854.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_14_2009",
    x1: 1439.02,
    y1: 960.147,
    x2: 1409.53,
    y2: 988.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_14_2009",
    x1: 27.3324,
    y1: 959.679,
    x2: -2.85114,
    y2: 988.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_14_2009",
    x1: 217.978,
    y1: 934.475,
    x2: 162.293,
    y2: 1040.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_14_2009",
    x1: 412.07,
    y1: 934.475,
    x2: 356.38,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_14_2009",
    x1: 606.195,
    y1: 934.475,
    x2: 550.504,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_14_2009",
    x1: 800.319,
    y1: 934.475,
    x2: 744.634,
    y2: 1040.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_14_2009",
    x1: 994.411,
    y1: 934.475,
    x2: 938.721,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_14_2009",
    x1: 1188.54,
    y1: 934.475,
    x2: 1132.85,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_14_2009",
    x1: 1382.66,
    y1: 934.475,
    x2: 1326.97,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_14_2009",
    x1: 1439.02,
    y1: 960.147,
    x2: 1409.53,
    y2: 988.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_14_2009",
    x1: 235.256,
    y1: 154.265,
    x2: 223.5,
    y2: 160.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_14_2009",
    x1: 761.242,
    y1: 21.7432,
    x2: 738.685,
    y2: 34.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_14_2009",
    x1: 757.581,
    y1: 110.527,
    x2: 743.473,
    y2: 118.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_14_2009",
    x1: 831.444,
    y1: 153.94,
    x2: 818.732,
    y2: 160.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_14_2009",
    x1: 906.007,
    y1: 25.0194,
    x2: 893.075,
    y2: 32.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_14_2009",
    x1: 910.241,
    y1: 107.601,
    x2: 887.537,
    y2: 120.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_14_2009",
    x1: 1056.98,
    y1: 23.4189,
    x2: 1039.34,
    y2: 33.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_14_2009",
    x1: 1058.44,
    y1: 108.177,
    x2: 1037.43,
    y2: 119.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_14_2009",
    x1: 1203.75,
    y1: 25.1193,
    x2: 1191.11,
    y2: 32.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_14_2009",
    x1: 1202.19,
    y1: 112.253,
    x2: 1193.15,
    y2: 117.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_14_2009",
    x1: 1353.04,
    y1: 24.8694,
    x2: 1339.66,
    y2: 32.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_14_2009",
    x1: 1353.83,
    y1: 110.152,
    x2: 1338.62,
    y2: 118.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_14_2009",
    x1: 162.188,
    y1: 282.044,
    x2: 147.179,
    y2: 290.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_14_2009",
    x1: 85.3004,
    y1: 240.982,
    x2: 75.8218,
    y2: 246.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_14_2009",
    x1: 84.3136,
    y1: 155.816,
    x2: 77.1128,
    y2: 159.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_14_2009",
    x1: 165.181,
    y1: 107.851,
    x2: 143.211,
    y2: 119.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_14_2009",
    x1: 238.153,
    y1: 237.931,
    x2: 219.71,
    y2: 248.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_14_2009",
    x1: 833.322,
    y1: 238.373,
    x2: 816.275,
    y2: 247.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_14_2009",
    x1: 978.66,
    y1: 155.324,
    x2: 969.916,
    y2: 160.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_14_2009",
    x1: 981.875,
    y1: 238.706,
    x2: 965.71,
    y2: 247.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_14_2009",
    x1: 1053.76,
    y1: 283.669,
    x2: 1043.55,
    y2: 289.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_14_2009",
    x1: 1134.15,
    y1: 150.172,
    x2: 1110.27,
    y2: 163.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_14_2009",
    x1: 1280.45,
    y1: 152.273,
    x2: 1262.74,
    y2: 162.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_14_2009",
    x1: 1354.88,
    y1: 281.143,
    x2: 1337.25,
    y2: 290.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_14_2009",
    x1: 1281.78,
    y1: 237.131,
    x2: 1260.99,
    y2: 248.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_14_2009",
    x1: 1429.92,
    y1: 151.814,
    x2: 1410.97,
    y2: 162.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_14_2009",
    x1: 906.293,
    y1: 282.519,
    x2: 892.7,
    y2: 290.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_14_2009",
    x1: 1128.55,
    y1: 240.482,
    x2: 1117.6,
    y2: 246.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_14_2009",
    x1: 1203.37,
    y1: 283.144,
    x2: 1191.61,
    y2: 289.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_14_2009",
    x1: 1426.74,
    y1: 412.073,
    x2: 1415.13,
    y2: 418.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_14_2009",
    x1: 1353.8,
    y1: 367.902,
    x2: 1338.66,
    y2: 376.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_14_2009",
    x1: 1427.98,
    y1: 239.281,
    x2: 1413.51,
    y2: 247.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_14_2009",
    x1: 163.111,
    y1: 539.018,
    x2: 145.917,
    y2: 548.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_14_2009",
    x1: 81.8618,
    y1: 501.408,
    x2: 80.3188,
    y2: 502.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_14_2009",
    x1: 87.1471,
    y1: 411.348,
    x2: 73.4068,
    y2: 418.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_14_2009",
    x1: 160.787,
    y1: 369.027,
    x2: 148.957,
    y2: 375.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_14_2009",
    x1: 309.278,
    y1: 541.219,
    x2: 298.55,
    y2: 547.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_14_2009",
    x1: 1056.92,
    y1: 367.135,
    x2: 1039.43,
    y2: 376.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_14_2009",
    x1: 1131.67,
    y1: 409.847,
    x2: 1113.52,
    y2: 419.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_14_2009",
    x1: 1203.02,
    y1: 541.144,
    x2: 1192.07,
    y2: 547.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_14_2009",
    x1: 1129.98,
    y1: 497.081,
    x2: 1115.73,
    y2: 504.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_14_2009",
    x1: 1204.86,
    y1: 367.877,
    x2: 1189.65,
    y2: 376.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_14_2009",
    x1: 1282.14,
    y1: 494.58,
    x2: 1260.53,
    y2: 506.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_14_2009",
    x1: 1352.53,
    y1: 540.752,
    x2: 1340.33,
    y2: 547.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_14_2009",
    x1: 1282.04,
    y1: 408.747,
    x2: 1260.66,
    y2: 420.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_14_2009",
    x1: 1425.91,
    y1: 498.632,
    x2: 1416.21,
    y2: 503.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_14_2009",
    x1: 239.205,
    y1: 494.855,
    x2: 218.391,
    y2: 506.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_14_2009",
    x1: 312.303,
    y1: 624.751,
    x2: 294.595,
    y2: 634.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_14_2009",
    x1: 457.194,
    y1: 627.927,
    x2: 448.818,
    y2: 632.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_14_2009",
    x1: 535.068,
    y1: 668.222,
    x2: 518.83,
    y2: 677.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_14_2009",
    x1: 609.313,
    y1: 625.426,
    x2: 593.589,
    y2: 634.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_14_2009",
    x1: 684.927,
    y1: 667.497,
    x2: 666.557,
    y2: 677.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_14_2009",
    x1: 160.246,
    y1: 799.027,
    x2: 149.665,
    y2: 804.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_14_2009",
    x1: 84.855,
    y1: 756.781,
    x2: 76.4051,
    y2: 761.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_14_2009",
    x1: 82.9783,
    y1: 672.374,
    x2: 78.937,
    y2: 674.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_14_2009",
    x1: 162.856,
    y1: 625.126,
    x2: 146.25,
    y2: 634.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_14_2009",
    x1: 236.05,
    y1: 755.005,
    x2: 222.384,
    y2: 762.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_14_2009",
    x1: 234.204,
    y1: 670.548,
    x2: 224.799,
    y2: 675.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_14_2009",
    x1: 382.44,
    y1: 671.123,
    x2: 374.725,
    y2: 675.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_14_2009",
    x1: 459.168,
    y1: 798.226,
    x2: 446.236,
    y2: 805.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_14_2009",
    x1: 387.184,
    y1: 753.305,
    x2: 368.52,
    y2: 763.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_14_2009",
    x1: 685.691,
    y1: 752.805,
    x2: 665.558,
    y2: 763.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_14_2009",
    x1: 1202.64,
    y1: 799.168,
    x2: 1192.57,
    y2: 804.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_14_2009",
    x1: 1203.37,
    y1: 626.777,
    x2: 1191.61,
    y2: 633.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_14_2009",
    x1: 1282.74,
    y1: 665.921,
    x2: 1259.74,
    y2: 678.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_14_2009",
    x1: 1352.65,
    y1: 626.527,
    x2: 1340.16,
    y2: 633.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_14_2009",
    x1: 1429.83,
    y1: 667.371,
    x2: 1411.09,
    y2: 677.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_14_2009",
    x1: 1432.53,
    y1: 751.154,
    x2: 1407.55,
    y2: 764.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_14_2009",
    x1: 310.01,
    y1: 798.402,
    x2: 297.592,
    y2: 805.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_14_2009",
    x1: 313.417,
    y1: 881.6,
    x2: 293.137,
    y2: 892.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_14_2009",
    x1: 537.202,
    y1: 752.455,
    x2: 516.04,
    y2: 764.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_14_2009",
    x1: 605.875,
    y1: 799.977,
    x2: 598.086,
    y2: 804.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_14_2009",
    x1: 683.717,
    y1: 926.205,
    x2: 668.14,
    y2: 934.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_14_2009",
    x1: 612.847,
    y1: 880.408,
    x2: 588.967,
    y2: 893.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_14_2009",
    x1: 1204.16,
    y1: 883.939,
    x2: 1190.61,
    y2: 891.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_14_2009",
    x1: 1354.88,
    y1: 796.626,
    x2: 1337.25,
    y2: 806.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_14_2009",
    x1: 1354.88,
    y1: 882.534,
    x2: 1337.25,
    y2: 892.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_14_2009",
    x1: 82.5624,
    y1: 930.399,
    x2: 79.4029,
    y2: 932.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_14_2009",
    x1: 160.087,
    y1: 885.06,
    x2: 149.873,
    y2: 890.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_14_2009",
    x1: 241.433,
    y1: 922.62,
    x2: 215.422,
    y2: 936.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_14_2009",
    x1: 385.911,
    y1: 926.121,
    x2: 370.186,
    y2: 934.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_14_2009",
    x1: 461.302,
    y1: 882.459,
    x2: 443.446,
    y2: 892.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_14_2009",
    x1: 536.883,
    y1: 924.521,
    x2: 516.456,
    y2: 935.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_14_2009",
    x1: 1129.89,
    y1: 926.697,
    x2: 1115.85,
    y2: 934.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_14_2009",
    x1: 1279.49,
    y1: 926.197,
    x2: 1263.99,
    y2: 934.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_14_2009",
    x1: 1178.27,
    y1: -34.7016,
    x2: 965.683,
    y2: 66.6629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_14_2009",
    x1: 1360.07,
    y1: -34.7016,
    x2: 1147.48,
    y2: 66.6629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_14_2009",
    x1: 1420.31,
    y1: -20.3497,
    x2: 1340.23,
    y2: -5.52214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_14_2009",
    x1: 1269.15,
    y1: 122.59,
    x2: 1056.57,
    y2: 223.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_14_2009",
    x1: 1418.05,
    y1: 122.561,
    x2: 1233.26,
    y2: 194.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_14_2009",
    x1: 89.4672,
    y1: 279.849,
    x2: -49.0076,
    y2: 317.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_14_2009",
    x1: 1360.07,
    y1: 279.849,
    x2: 1147.48,
    y2: 381.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_14_2009",
    x1: 1420.31,
    y1: 294.234,
    x2: 1340.23,
    y2: 309.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_14_2009",
    x1: 0.838575,
    y1: 470.806,
    x2: -17.9087,
    y2: 471.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_14_2009",
    x1: 178.402,
    y1: 437.141,
    x2: -34.1855,
    y2: 538.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_14_2009",
    x1: 360.199,
    y1: 437.141,
    x2: 147.612,
    y2: 538.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_14_2009",
    x1: 541.997,
    y1: 437.141,
    x2: 329.409,
    y2: 538.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_14_2009",
    x1: 89.4672,
    y1: 594.404,
    x2: -49.0106,
    y2: 632.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_14_2009",
    x1: 269.318,
    y1: 594.433,
    x2: 56.7301,
    y2: 695.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_14_2009",
    x1: 451.081,
    y1: 594.433,
    x2: 238.494,
    y2: 695.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_14_2009",
    x1: 0.838575,
    y1: 785.386,
    x2: -17.9086,
    y2: 786.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_14_2009",
    x1: 178.402,
    y1: 751.725,
    x2: -34.1854,
    y2: 853.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_14_2009",
    x1: 360.199,
    y1: 751.725,
    x2: 147.612,
    y2: 853.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_14_2009",
    x1: 541.997,
    y1: 751.725,
    x2: 329.409,
    y2: 853.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_14_2009",
    x1: 1269.15,
    y1: 751.725,
    x2: 1056.57,
    y2: 853.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_14_2009",
    x1: 1418.05,
    y1: 751.695,
    x2: 1233.26,
    y2: 823.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_14_2009",
    x1: 89.4672,
    y1: 892.914,
    x2: -11.6278,
    y2: 962.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_14_2009",
    x1: 269.317,
    y1: 892.914,
    x2: 162.815,
    y2: 1021.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_14_2009",
    x1: 451.114,
    y1: 892.914,
    x2: 344.612,
    y2: 1021.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_14_2009",
    x1: 632.911,
    y1: 892.914,
    x2: 526.409,
    y2: 1021.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_14_2009",
    x1: 1360.07,
    y1: 892.914,
    x2: 1253.56,
    y2: 1021.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_14_2009",
    x1: 1420.31,
    y1: 909.726,
    x2: 1353.88,
    y2: 942.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_14_2009",
    x1: 1298.76,
    y1: -129.42,
    x2: 1076.53,
    y2: 35.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_14_2009",
    x1: 1418.74,
    y1: -129.42,
    x2: 1266.74,
    y2: -72.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_14_2009",
    x1: 1.29593,
    y1: 34.8807,
    x2: -18.1436,
    y2: 35.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_14_2009",
    x1: 232.594,
    y1: -11.1897,
    x2: -48.0867,
    y2: 122.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_14_2009",
    x1: 1421.68,
    y1: 39.6078,
    x2: 1417.85,
    y2: 39.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_14_2009",
    x1: 116.81,
    y1: 193.792,
    x2: -59.8961,
    y2: 239.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_14_2009",
    x1: 351.045,
    y1: 193.792,
    x2: 70.3645,
    y2: 327.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_14_2009",
    x1: 1.29593,
    y1: 444.844,
    x2: -18.1436,
    y2: 445.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_14_2009",
    x1: 232.594,
    y1: 398.777,
    x2: -48.0992,
    y2: 532.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_14_2009",
    x1: 1415.8,
    y1: 398.773,
    x2: 1136.18,
    y2: 531.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_14_2009",
    x1: 116.81,
    y1: 603.759,
    x2: -59.8988,
    y2: 649.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_14_2009",
    x1: 351.045,
    y1: 603.788,
    x2: 70.3645,
    y2: 737.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_14_2009",
    x1: 1298.76,
    y1: 603.788,
    x2: 1018.08,
    y2: 737.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_14_2009",
    x1: 1418.74,
    y1: 603.759,
    x2: 1255.02,
    y2: 642.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_14_2009",
    x1: 1.29593,
    y1: 851.746,
    x2: -18.1251,
    y2: 852.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_14_2009",
    x1: 232.594,
    y1: 797.888,
    x2: -0.802327,
    y2: 958.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_14_2009",
    x1: 469.497,
    y1: 797.888,
    x2: 236.113,
    y2: 958.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_14_2009",
    x1: 706.433,
    y1: 797.888,
    x2: 473.049,
    y2: 958.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_14_2009",
    x1: 943.368,
    y1: 797.888,
    x2: 709.973,
    y2: 958.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_14_2009",
    x1: 1180.27,
    y1: 797.888,
    x2: 946.887,
    y2: 958.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_14_2009",
    x1: 1415.8,
    y1: 797.888,
    x2: 1182.92,
    y2: 957.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_14_2009",
    x1: 1421.68,
    y1: 857.272,
    x2: 1417.85,
    y2: 857.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_14_2009",
    x1: 1373.52,
    y1: -15.7575,
    x2: 1351.99,
    y2: -3.90442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_14_2009",
    x1: 1372.18,
    y1: 90.1433,
    x2: 1353.74,
    y2: 100.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_14_2009",
    x1: 97.312,
    y1: 301.67,
    x2: 84.233,
    y2: 308.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_14_2009",
    x1: 1009.86,
    y1: 89.1679,
    x2: 988.556,
    y2: 100.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_14_2009",
    x1: 1101.1,
    y1: 141.301,
    x2: 1078.98,
    y2: 153.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_14_2009",
    x1: 1188.19,
    y1: 301.569,
    x2: 1174.82,
    y2: 308.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_14_2009",
    x1: 1099.06,
    y1: 247.752,
    x2: 1081.64,
    y2: 257.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_14_2009",
    x1: 1190.45,
    y1: 90.0933,
    x2: 1171.86,
    y2: 100.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_14_2009",
    x1: 1284.74,
    y1: 244.7,
    x2: 1258.36,
    y2: 259.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_14_2009",
    x1: 1370.66,
    y1: 301.044,
    x2: 1355.74,
    y2: 309.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_14_2009",
    x1: 1284.61,
    y1: 139.984,
    x2: 1258.53,
    y2: 154.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_14_2009",
    x1: 11.7787,
    y1: 245.026,
    x2: -13.6445,
    y2: 259.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_14_2009",
    x1: 101.005,
    y1: 403.618,
    x2: 79.4028,
    y2: 415.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_14_2009",
    x1: 277.9,
    y1: 407.47,
    x2: 267.613,
    y2: 413.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_14_2009",
    x1: 372.92,
    y1: 456.66,
    x2: 353.081,
    y2: 467.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_14_2009",
    x1: 463.549,
    y1: 404.444,
    x2: 444.371,
    y2: 415.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_14_2009",
    x1: 555.832,
    y1: 455.785,
    x2: 533.421,
    y2: 468.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_14_2009",
    x1: 7.95682,
    y1: 562.586,
    x2: -8.7226,
    y2: 571.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_14_2009",
    x1: 5.72957,
    y1: 459.511,
    x2: -5.73293,
    y2: 465.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_14_2009",
    x1: 186.636,
    y1: 460.212,
    x2: 177.23,
    y2: 465.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_14_2009",
    x1: 280.287,
    y1: 615.328,
    x2: 264.489,
    y2: 624.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_14_2009",
    x1: 192.43,
    y1: 560.544,
    x2: 169.652,
    y2: 573.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_14_2009",
    x1: 556.755,
    y1: 559.91,
    x2: 532.213,
    y2: 573.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_14_2009",
    x1: 1187.71,
    y1: 616.495,
    x2: 1175.44,
    y2: 623.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_14_2009",
    x1: 1188.6,
    y1: 406.094,
    x2: 1174.28,
    y2: 413.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_14_2009",
    x1: 1285.47,
    y1: 453.859,
    x2: 1257.4,
    y2: 469.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_14_2009",
    x1: 1370.78,
    y1: 405.828,
    x2: 1355.57,
    y2: 414.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_14_2009",
    x1: 98.2034,
    y1: 615.553,
    x2: 83.067,
    y2: 623.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_14_2009",
    x1: 102.374,
    y1: 717.093,
    x2: 77.6124,
    y2: 730.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_14_2009",
    x1: 375.531,
    y1: 559.46,
    x2: 349.667,
    y2: 573.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_14_2009",
    x1: 459.346,
    y1: 617.479,
    x2: 449.868,
    y2: 622.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_14_2009",
    x1: 554.367,
    y1: 771.519,
    x2: 535.337,
    y2: 781.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_14_2009",
    x1: 467.847,
    y1: 715.618,
    x2: 438.75,
    y2: 731.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_14_2009",
    x1: 1189.59,
    y1: 719.928,
    x2: 1173.06,
    y2: 729.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_14_2009",
    x1: 1373.52,
    y1: 613.377,
    x2: 1351.99,
    y2: 625.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_14_2009",
    x1: 1373.52,
    y1: 718.227,
    x2: 1351.99,
    y2: 730.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_14_2009",
    x1: 14.5592,
    y1: 767.159,
    x2: -16.1273,
    y2: 783.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_14_2009",
    x1: 97.5666,
    y1: 930.637,
    x2: 83.8998,
    y2: 938.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_14_2009",
    x1: 194.277,
    y1: 873.643,
    x2: 167.237,
    y2: 888.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_14_2009",
    x1: 190.87,
    y1: 771.47,
    x2: 171.692,
    y2: 782.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_14_2009",
    x1: 282.898,
    y1: 718.127,
    x2: 261.075,
    y2: 730.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_14_2009",
    x1: 375.15,
    y1: 769.519,
    x2: 350.242,
    y2: 783.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_14_2009",
    x1: 463.74,
    y1: 928.578,
    x2: 444.122,
    y2: 939.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_14_2009",
    x1: 555.1,
    y1: 875.795,
    x2: 534.379,
    y2: 887.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_14_2009",
    x1: 1098.93,
    y1: 772.17,
    x2: 1081.81,
    y2: 781.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_14_2009",
    x1: 1281.52,
    y1: 771.544,
    x2: 1262.57,
    y2: 781.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_14_2009",
    x1: 5.22032,
    y1: 879.346,
    x2: -5.06652,
    y2: 885.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_14_2009",
    x1: 284.649,
    y1: 926.452,
    x2: 258.785,
    y2: 940.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_14_2009",
    x1: 369.323,
    y1: 878.921,
    x2: 357.787,
    y2: 885.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_14_2009",
    x1: 643.659,
    y1: 930.054,
    x2: 628.375,
    y2: 938.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_14_2009",
    x1: 1099.82,
    y1: 876.32,
    x2: 1080.65,
    y2: 886.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_14_2009",
    x1: 1187.08,
    y1: 931.604,
    x2: 1176.35,
    y2: 937.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_14_2009",
    x1: 1281.94,
    y1: 876.07,
    x2: 1262.03,
    y2: 887.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_14_2009",
    x1: 1374.41,
    y1: 927.227,
    x2: 1350.83,
    y2: 940.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_2009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14_2009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1452,
    height: 1132,
    fill: "white",
    transform: "translate(-12 -152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginScreenLight);
export default __webpack_public_path__ + "static/media/loginScreenLight.a77c09696c73ee289c6fc03e91d18b76.svg";
export { ForwardRef as ReactComponent };